"function" != typeof Object.create &&
    (Object.create = function (d) {
        function c() {}
        return (c.prototype = d), new c();
    }),
    (function (g, f, j, i) {
        var h = {
            init: function (a, k) {
                var e = this;
                (e.elem = k),
                    (e.$elem = g(k)),
                    (e.imageSrc = e.$elem.data("zoom-image")
                        ? e.$elem.data("zoom-image")
                        : e.$elem.attr("src")),
                    (e.options = g.extend({}, g.fn.elevateZoom.options, a)),
                    e.options.tint &&
                        ((e.options.lensColour = "none"),
                        (e.options.lensOpacity = "1")),
                    "inner" == e.options.zoomType && (e.options.showLens = !1),
                    e.$elem.parent().removeAttr("title").removeAttr("alt"),
                    (e.zoomImage = e.imageSrc),
                    e.refresh(1),
                    g("#" + e.options.gallery + " a").click(function (c) {
                        return (
                            e.options.galleryActiveClass &&
                                (g("#" + e.options.gallery + " a").removeClass(
                                    e.options.galleryActiveClass
                                ),
                                g(this).addClass(e.options.galleryActiveClass)),
                            c.preventDefault(),
                            g(this).data("zoom-image")
                                ? (e.zoomImagePre = g(this).data("zoom-image"))
                                : (e.zoomImagePre = g(this).data("image")),
                            e.swaptheimage(
                                g(this).data("image"),
                                e.zoomImagePre
                            ),
                            !1
                        );
                    });
            },
            refresh: function (d) {
                var c = this;
                setTimeout(function () {
                    c.fetch(c.imageSrc);
                }, d || c.options.refresh);
            },
            fetch: function (e) {
                var d = this,
                    k = new Image();
                (k.onload = function () {
                    (d.largeWidth = k.width),
                        (d.largeHeight = k.height),
                        d.startZoom(),
                        (d.currentImage = d.imageSrc),
                        d.options.onZoomedImageLoaded(d.$elem);
                }),
                    (k.src = e);
            },
            startZoom: function () {
                var a = this;
                if (
                    ((a.nzWidth = a.$elem.width()),
                    (a.nzHeight = a.$elem.height()),
                    (a.isWindowActive = !1),
                    (a.isLensActive = !1),
                    (a.isTintActive = !1),
                    (a.overWindow = !1),
                    a.options.imageCrossfade &&
                        ((a.zoomWrap = a.$elem.wrap(
                            '<div style="height:' +
                                a.nzHeight +
                                "px;width:" +
                                a.nzWidth +
                                'px;" class="zoomWrapper" />'
                        )),
                        a.$elem.css("position", "absolute")),
                    (a.zoomLock = 1),
                    (a.scrollingLock = !1),
                    (a.changeBgSize = !1),
                    (a.currentZoomLevel = a.options.zoomLevel),
                    (a.nzOffset = a.$elem.offset()),
                    (a.widthRatio =
                        a.largeWidth / a.currentZoomLevel / a.nzWidth),
                    (a.heightRatio =
                        a.largeHeight / a.currentZoomLevel / a.nzHeight),
                    "window" == a.options.zoomType &&
                        (a.zoomWindowStyle =
                            "overflow: hidden;background-position: 0px 0px;text-align:center;background-color: " +
                            String(a.options.zoomWindowBgColour) +
                            ";width: " +
                            String(a.options.zoomWindowWidth) +
                            "px;height: " +
                            String(a.options.zoomWindowHeight) +
                            "px;float: left;background-size: " +
                            a.largeWidth / a.currentZoomLevel +
                            "px " +
                            a.largeHeight / a.currentZoomLevel +
                            "px;display: none;z-index:100;border: " +
                            String(a.options.borderSize) +
                            "px solid " +
                            a.options.borderColour +
                            ";background-repeat: no-repeat;position: absolute;"),
                    "inner" == a.options.zoomType)
                ) {
                    var d = a.$elem.css("border-left-width");
                    a.zoomWindowStyle =
                        "overflow: hidden;margin-left: " +
                        String(d) +
                        ";margin-top: " +
                        String(d) +
                        ";background-position: 0px 0px;width: " +
                        String(a.nzWidth) +
                        "px;height: " +
                        String(a.nzHeight) +
                        "px;float: left;display: none;cursor:" +
                        a.options.cursor +
                        ";px solid " +
                        a.options.borderColour +
                        ";background-repeat: no-repeat;position: absolute;";
                }
                "window" == a.options.zoomType &&
                    ((lensHeight =
                        a.nzHeight < a.options.zoomWindowWidth / a.widthRatio
                            ? a.nzHeight
                            : String(
                                  a.options.zoomWindowHeight / a.heightRatio
                              )),
                    (lensWidth =
                        a.largeWidth < a.options.zoomWindowWidth
                            ? a.nzWidth
                            : a.options.zoomWindowWidth / a.widthRatio),
                    (a.lensStyle =
                        "background-position: 0px 0px;width: " +
                        String(a.options.zoomWindowWidth / a.widthRatio) +
                        "px;height: " +
                        String(a.options.zoomWindowHeight / a.heightRatio) +
                        "px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:" +
                        a.options.lensOpacity +
                        ";filter: alpha(opacity = " +
                        100 * a.options.lensOpacity +
                        "); zoom:1;width:" +
                        lensWidth +
                        "px;height:" +
                        lensHeight +
                        "px;background-color:" +
                        a.options.lensColour +
                        ";cursor:" +
                        a.options.cursor +
                        ";border: " +
                        a.options.lensBorderSize +
                        "px solid " +
                        a.options.lensBorderColour +
                        ";background-repeat: no-repeat;position: absolute;")),
                    (a.tintStyle =
                        "display: block;position: absolute;background-color: " +
                        a.options.tintColour +
                        ";filter:alpha(opacity=0);opacity: 0;width: " +
                        a.nzWidth +
                        "px;height: " +
                        a.nzHeight +
                        "px;"),
                    (a.lensRound = ""),
                    "lens" == a.options.zoomType &&
                        (a.lensStyle =
                            "background-position: 0px 0px;float: left;display: none;border: " +
                            String(a.options.borderSize) +
                            "px solid " +
                            a.options.borderColour +
                            ";width:" +
                            String(a.options.lensSize) +
                            "px;height:" +
                            String(a.options.lensSize) +
                            "px;background-repeat: no-repeat;position: absolute;"),
                    "round" == a.options.lensShape &&
                        (a.lensRound =
                            "border-top-left-radius: " +
                            String(
                                a.options.lensSize / 2 + a.options.borderSize
                            ) +
                            "px;border-top-right-radius: " +
                            String(
                                a.options.lensSize / 2 + a.options.borderSize
                            ) +
                            "px;border-bottom-left-radius: " +
                            String(
                                a.options.lensSize / 2 + a.options.borderSize
                            ) +
                            "px;border-bottom-right-radius: " +
                            String(
                                a.options.lensSize / 2 + a.options.borderSize
                            ) +
                            "px;"),
                    (a.zoomContainer = g(
                        '<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:' +
                            a.nzOffset.left +
                            "px;top:" +
                            a.nzOffset.top +
                            "px;height:" +
                            a.nzHeight +
                            "px;width:" +
                            a.nzWidth +
                            'px;"></div>'
                    )),
                    g("body").append(a.zoomContainer),
                    a.options.containLensZoom &&
                        "lens" == a.options.zoomType &&
                        a.zoomContainer.css("overflow", "hidden"),
                    "inner" != a.options.zoomType &&
                        ((a.zoomLens = g(
                            "<div class='zoomLens' style='" +
                                a.lensStyle +
                                a.lensRound +
                                "'>&nbsp;</div>"
                        )
                            .appendTo(a.zoomContainer)
                            .click(function () {
                                a.$elem.trigger("click");
                            })),
                        a.options.tint &&
                            ((a.tintContainer = g("<div/>").addClass(
                                "tintContainer"
                            )),
                            (a.zoomTint = g(
                                "<div class='zoomTint' style='" +
                                    a.tintStyle +
                                    "'></div>"
                            )),
                            a.zoomLens.wrap(a.tintContainer),
                            (a.zoomTintcss = a.zoomLens.after(a.zoomTint)),
                            (a.zoomTintImage = g(
                                '<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' +
                                    a.nzWidth +
                                    "px; height: " +
                                    a.nzHeight +
                                    'px;" src="' +
                                    a.imageSrc +
                                    '">'
                            )
                                .appendTo(a.zoomLens)
                                .click(function () {
                                    a.$elem.trigger("click");
                                })))),
                    isNaN(a.options.zoomWindowPosition)
                        ? (a.zoomWindow = g(
                              "<div style='z-index:999;left:" +
                                  a.windowOffsetLeft +
                                  "px;top:" +
                                  a.windowOffsetTop +
                                  "px;" +
                                  a.zoomWindowStyle +
                                  "' class='zoomWindow'>&nbsp;</div>"
                          )
                              .appendTo("body")
                              .click(function () {
                                  a.$elem.trigger("click");
                              }))
                        : (a.zoomWindow = g(
                              "<div style='z-index:999;left:" +
                                  a.windowOffsetLeft +
                                  "px;top:" +
                                  a.windowOffsetTop +
                                  "px;" +
                                  a.zoomWindowStyle +
                                  "' class='zoomWindow'>&nbsp;</div>"
                          )
                              .appendTo(a.zoomContainer)
                              .click(function () {
                                  a.$elem.trigger("click");
                              })),
                    (a.zoomWindowContainer = g("<div/>")
                        .addClass("zoomWindowContainer")
                        .css("width", a.options.zoomWindowWidth)),
                    a.zoomWindow.wrap(a.zoomWindowContainer),
                    "lens" == a.options.zoomType &&
                        a.zoomLens.css({
                            backgroundImage: "url('" + a.imageSrc + "')",
                        }),
                    "window" == a.options.zoomType &&
                        a.zoomWindow.css({
                            backgroundImage: "url('" + a.imageSrc + "')",
                        }),
                    "inner" == a.options.zoomType &&
                        a.zoomWindow.css({
                            backgroundImage: "url('" + a.imageSrc + "')",
                        }),
                    a.$elem.bind("touchmove", function (b) {
                        b.preventDefault(),
                            a.setPosition(
                                b.originalEvent.touches[0] ||
                                    b.originalEvent.changedTouches[0]
                            );
                    }),
                    a.zoomContainer.bind("touchmove", function (b) {
                        "inner" == a.options.zoomType &&
                            a.showHideWindow("show"),
                            b.preventDefault(),
                            a.setPosition(
                                b.originalEvent.touches[0] ||
                                    b.originalEvent.changedTouches[0]
                            );
                    }),
                    a.zoomContainer.bind("touchend", function (b) {
                        a.showHideWindow("hide"),
                            a.options.showLens && a.showHideLens("hide"),
                            a.options.tint &&
                                "inner" != a.options.zoomType &&
                                a.showHideTint("hide");
                    }),
                    a.$elem.bind("touchend", function (b) {
                        a.showHideWindow("hide"),
                            a.options.showLens && a.showHideLens("hide"),
                            a.options.tint &&
                                "inner" != a.options.zoomType &&
                                a.showHideTint("hide");
                    }),
                    a.options.showLens &&
                        (a.zoomLens.bind("touchmove", function (b) {
                            b.preventDefault(),
                                a.setPosition(
                                    b.originalEvent.touches[0] ||
                                        b.originalEvent.changedTouches[0]
                                );
                        }),
                        a.zoomLens.bind("touchend", function (b) {
                            a.showHideWindow("hide"),
                                a.options.showLens && a.showHideLens("hide"),
                                a.options.tint &&
                                    "inner" != a.options.zoomType &&
                                    a.showHideTint("hide");
                        })),
                    a.$elem.bind("mousemove", function (b) {
                        0 == a.overWindow && a.setElements("show"),
                            (a.lastX === b.clientX && a.lastY === b.clientY) ||
                                (a.setPosition(b), (a.currentLoc = b)),
                            (a.lastX = b.clientX),
                            (a.lastY = b.clientY);
                    }),
                    a.zoomContainer.bind("mousemove", function (b) {
                        0 == a.overWindow && a.setElements("show"),
                            (a.lastX === b.clientX && a.lastY === b.clientY) ||
                                (a.setPosition(b), (a.currentLoc = b)),
                            (a.lastX = b.clientX),
                            (a.lastY = b.clientY);
                    }),
                    "inner" != a.options.zoomType &&
                        a.zoomLens.bind("mousemove", function (b) {
                            (a.lastX === b.clientX && a.lastY === b.clientY) ||
                                (a.setPosition(b), (a.currentLoc = b)),
                                (a.lastX = b.clientX),
                                (a.lastY = b.clientY);
                        }),
                    a.options.tint &&
                        "inner" != a.options.zoomType &&
                        a.zoomTint.bind("mousemove", function (b) {
                            (a.lastX === b.clientX && a.lastY === b.clientY) ||
                                (a.setPosition(b), (a.currentLoc = b)),
                                (a.lastX = b.clientX),
                                (a.lastY = b.clientY);
                        }),
                    "inner" == a.options.zoomType &&
                        a.zoomWindow.bind("mousemove", function (b) {
                            (a.lastX === b.clientX && a.lastY === b.clientY) ||
                                (a.setPosition(b), (a.currentLoc = b)),
                                (a.lastX = b.clientX),
                                (a.lastY = b.clientY);
                        }),
                    a.zoomContainer
                        .add(a.$elem)
                        .mouseenter(function () {
                            0 == a.overWindow && a.setElements("show");
                        })
                        .mouseleave(function () {
                            a.scrollLock || a.setElements("hide");
                        }),
                    "inner" != a.options.zoomType &&
                        a.zoomWindow
                            .mouseenter(function () {
                                (a.overWindow = !0), a.setElements("hide");
                            })
                            .mouseleave(function () {
                                a.overWindow = !1;
                            }),
                    (a.minZoomLevel = a.options.minZoomLevel
                        ? a.options.minZoomLevel
                        : 2 * a.options.scrollZoomIncrement),
                    a.options.scrollZoom &&
                        a.zoomContainer
                            .add(a.$elem)
                            .bind(
                                "mousewheel DOMMouseScroll MozMousePixelScroll",
                                function (e) {
                                    (a.scrollLock = !0),
                                        clearTimeout(g.data(this, "timer")),
                                        g.data(
                                            this,
                                            "timer",
                                            setTimeout(function () {
                                                a.scrollLock = !1;
                                            }, 250)
                                        );
                                    var b =
                                        e.originalEvent.wheelDelta ||
                                        -1 * e.originalEvent.detail;
                                    return (
                                        e.stopImmediatePropagation(),
                                        e.stopPropagation(),
                                        e.preventDefault(),
                                        0 < b / 120
                                            ? a.currentZoomLevel >=
                                                  a.minZoomLevel &&
                                              a.changeZoomLevel(
                                                  a.currentZoomLevel -
                                                      a.options
                                                          .scrollZoomIncrement
                                              )
                                            : a.options.maxZoomLevel
                                            ? a.currentZoomLevel <=
                                                  a.options.maxZoomLevel &&
                                              a.changeZoomLevel(
                                                  parseFloat(
                                                      a.currentZoomLevel
                                                  ) +
                                                      a.options
                                                          .scrollZoomIncrement
                                              )
                                            : a.changeZoomLevel(
                                                  parseFloat(
                                                      a.currentZoomLevel
                                                  ) +
                                                      a.options
                                                          .scrollZoomIncrement
                                              ),
                                        !1
                                    );
                                }
                            );
            },
            setElements: function (b) {
                return (
                    !!this.options.zoomEnabled &&
                    ("show" == b &&
                        this.isWindowSet &&
                        ("inner" == this.options.zoomType &&
                            this.showHideWindow("show"),
                        "window" == this.options.zoomType &&
                            this.showHideWindow("show"),
                        this.options.showLens && this.showHideLens("show"),
                        this.options.tint &&
                            "inner" != this.options.zoomType &&
                            this.showHideTint("show")),
                    void (
                        "hide" == b &&
                        ("window" == this.options.zoomType &&
                            this.showHideWindow("hide"),
                        this.options.tint || this.showHideWindow("hide"),
                        this.options.showLens && this.showHideLens("hide"),
                        this.options.tint && this.showHideTint("hide"))
                    ))
                );
            },
            setPosition: function (b) {
                return (
                    !!this.options.zoomEnabled &&
                    ((this.nzHeight = this.$elem.height()),
                    (this.nzWidth = this.$elem.width()),
                    (this.nzOffset = this.$elem.offset()),
                    this.options.tint &&
                        "inner" != this.options.zoomType &&
                        (this.zoomTint.css({ top: 0 }),
                        this.zoomTint.css({ left: 0 })),
                    this.options.responsive &&
                        !this.options.scrollZoom &&
                        this.options.showLens &&
                        ((lensHeight =
                            this.nzHeight <
                            this.options.zoomWindowWidth / this.widthRatio
                                ? this.nzHeight
                                : String(
                                      this.options.zoomWindowHeight /
                                          this.heightRatio
                                  )),
                        (lensWidth =
                            this.largeWidth < this.options.zoomWindowWidth
                                ? this.nzWidth
                                : this.options.zoomWindowWidth /
                                  this.widthRatio),
                        (this.widthRatio = this.largeWidth / this.nzWidth),
                        (this.heightRatio = this.largeHeight / this.nzHeight),
                        "lens" != this.options.zoomType &&
                            ((lensHeight =
                                this.nzHeight <
                                this.options.zoomWindowWidth / this.widthRatio
                                    ? this.nzHeight
                                    : String(
                                          this.options.zoomWindowHeight /
                                              this.heightRatio
                                      )),
                            (lensWidth =
                                this.options.zoomWindowWidth <
                                this.options.zoomWindowWidth
                                    ? this.nzWidth
                                    : this.options.zoomWindowWidth /
                                      this.widthRatio),
                            this.zoomLens.css("width", lensWidth),
                            this.zoomLens.css("height", lensHeight),
                            this.options.tint &&
                                (this.zoomTintImage.css("width", this.nzWidth),
                                this.zoomTintImage.css(
                                    "height",
                                    this.nzHeight
                                ))),
                        "lens" == this.options.zoomType &&
                            this.zoomLens.css({
                                width: String(this.options.lensSize) + "px",
                                height: String(this.options.lensSize) + "px",
                            })),
                    this.zoomContainer.css({ top: this.nzOffset.top }),
                    this.zoomContainer.css({ left: this.nzOffset.left }),
                    (this.mouseLeft = parseInt(b.pageX - this.nzOffset.left)),
                    (this.mouseTop = parseInt(b.pageY - this.nzOffset.top)),
                    "window" == this.options.zoomType &&
                        ((this.Etoppos =
                            this.mouseTop < this.zoomLens.height() / 2),
                        (this.Eboppos =
                            this.mouseTop >
                            this.nzHeight -
                                this.zoomLens.height() / 2 -
                                2 * this.options.lensBorderSize),
                        (this.Eloppos =
                            this.mouseLeft < 0 + this.zoomLens.width() / 2),
                        (this.Eroppos =
                            this.mouseLeft >
                            this.nzWidth -
                                this.zoomLens.width() / 2 -
                                2 * this.options.lensBorderSize)),
                    "inner" == this.options.zoomType &&
                        ((this.Etoppos =
                            this.mouseTop <
                            this.nzHeight / 2 / this.heightRatio),
                        (this.Eboppos =
                            this.mouseTop >
                            this.nzHeight -
                                this.nzHeight / 2 / this.heightRatio),
                        (this.Eloppos =
                            this.mouseLeft <
                            0 + this.nzWidth / 2 / this.widthRatio),
                        (this.Eroppos =
                            this.mouseLeft >
                            this.nzWidth -
                                this.nzWidth / 2 / this.widthRatio -
                                2 * this.options.lensBorderSize)),
                    void (0 >= this.mouseLeft ||
                    0 > this.mouseTop ||
                    this.mouseLeft > this.nzWidth ||
                    this.mouseTop > this.nzHeight
                        ? this.setElements("hide")
                        : (this.options.showLens &&
                              ((this.lensLeftPos = String(
                                  this.mouseLeft - this.zoomLens.width() / 2
                              )),
                              (this.lensTopPos = String(
                                  this.mouseTop - this.zoomLens.height() / 2
                              ))),
                          this.Etoppos && (this.lensTopPos = 0),
                          this.Eloppos &&
                              (this.tintpos = this.lensLeftPos = this.windowLeftPos = 0),
                          "window" == this.options.zoomType &&
                              (this.Eboppos &&
                                  (this.lensTopPos = Math.max(
                                      this.nzHeight -
                                          this.zoomLens.height() -
                                          2 * this.options.lensBorderSize,
                                      0
                                  )),
                              this.Eroppos &&
                                  (this.lensLeftPos =
                                      this.nzWidth -
                                      this.zoomLens.width() -
                                      2 * this.options.lensBorderSize)),
                          "inner" == this.options.zoomType &&
                              (this.Eboppos &&
                                  (this.lensTopPos = Math.max(
                                      this.nzHeight -
                                          2 * this.options.lensBorderSize,
                                      0
                                  )),
                              this.Eroppos &&
                                  (this.lensLeftPos =
                                      this.nzWidth -
                                      this.nzWidth -
                                      2 * this.options.lensBorderSize)),
                          "lens" == this.options.zoomType &&
                              ((this.windowLeftPos = String(
                                  -1 *
                                      ((b.pageX - this.nzOffset.left) *
                                          this.widthRatio -
                                          this.zoomLens.width() / 2)
                              )),
                              (this.windowTopPos = String(
                                  -1 *
                                      ((b.pageY - this.nzOffset.top) *
                                          this.heightRatio -
                                          this.zoomLens.height() / 2)
                              )),
                              this.zoomLens.css({
                                  backgroundPosition:
                                      this.windowLeftPos +
                                      "px " +
                                      this.windowTopPos +
                                      "px",
                              }),
                              this.changeBgSize &&
                                  (this.nzHeight > this.nzWidth
                                      ? ("lens" == this.options.zoomType &&
                                            this.zoomLens.css({
                                                "background-size":
                                                    this.largeWidth /
                                                        this.newvalueheight +
                                                    "px " +
                                                    this.largeHeight /
                                                        this.newvalueheight +
                                                    "px",
                                            }),
                                        this.zoomWindow.css({
                                            "background-size":
                                                this.largeWidth /
                                                    this.newvalueheight +
                                                "px " +
                                                this.largeHeight /
                                                    this.newvalueheight +
                                                "px",
                                        }))
                                      : ("lens" == this.options.zoomType &&
                                            this.zoomLens.css({
                                                "background-size":
                                                    this.largeWidth /
                                                        this.newvaluewidth +
                                                    "px " +
                                                    this.largeHeight /
                                                        this.newvaluewidth +
                                                    "px",
                                            }),
                                        this.zoomWindow.css({
                                            "background-size":
                                                this.largeWidth /
                                                    this.newvaluewidth +
                                                "px " +
                                                this.largeHeight /
                                                    this.newvaluewidth +
                                                "px",
                                        })),
                                  (this.changeBgSize = !1)),
                              this.setWindowPostition(b)),
                          this.options.tint &&
                              "inner" != this.options.zoomType &&
                              this.setTintPosition(b),
                          "window" == this.options.zoomType &&
                              this.setWindowPostition(b),
                          "inner" == this.options.zoomType &&
                              this.setWindowPostition(b),
                          this.options.showLens &&
                              (this.fullwidth &&
                                  "lens" != this.options.zoomType &&
                                  (this.lensLeftPos = 0),
                              this.zoomLens.css({
                                  left: this.lensLeftPos + "px",
                                  top: this.lensTopPos + "px",
                              })))))
                );
            },
            showHideWindow: function (b) {
                "show" != b ||
                    this.isWindowActive ||
                    (this.options.zoomWindowFadeIn
                        ? this.zoomWindow
                              .stop(!0, !0, !1)
                              .fadeIn(this.options.zoomWindowFadeIn)
                        : this.zoomWindow.show(),
                    (this.isWindowActive = !0)),
                    "hide" == b &&
                        this.isWindowActive &&
                        (this.options.zoomWindowFadeOut
                            ? this.zoomWindow
                                  .stop(!0, !0)
                                  .fadeOut(this.options.zoomWindowFadeOut)
                            : this.zoomWindow.hide(),
                        (this.isWindowActive = !1));
            },
            showHideLens: function (b) {
                "show" != b ||
                    this.isLensActive ||
                    (this.options.lensFadeIn
                        ? this.zoomLens
                              .stop(!0, !0, !1)
                              .fadeIn(this.options.lensFadeIn)
                        : this.zoomLens.show(),
                    (this.isLensActive = !0)),
                    "hide" == b &&
                        this.isLensActive &&
                        (this.options.lensFadeOut
                            ? this.zoomLens
                                  .stop(!0, !0)
                                  .fadeOut(this.options.lensFadeOut)
                            : this.zoomLens.hide(),
                        (this.isLensActive = !1));
            },
            showHideTint: function (b) {
                "show" != b ||
                    this.isTintActive ||
                    (this.options.zoomTintFadeIn
                        ? this.zoomTint
                              .css({ opacity: this.options.tintOpacity })
                              .animate()
                              .stop(!0, !0)
                              .fadeIn("slow")
                        : (this.zoomTint
                              .css({ opacity: this.options.tintOpacity })
                              .animate(),
                          this.zoomTint.show()),
                    (this.isTintActive = !0)),
                    "hide" == b &&
                        this.isTintActive &&
                        (this.options.zoomTintFadeOut
                            ? this.zoomTint
                                  .stop(!0, !0)
                                  .fadeOut(this.options.zoomTintFadeOut)
                            : this.zoomTint.hide(),
                        (this.isTintActive = !1));
            },
            setLensPostition: function (b) {},
            setWindowPostition: function (a) {
                var d = this;
                if (isNaN(d.options.zoomWindowPosition)) {
                    (d.externalContainer = g(
                        "#" + d.options.zoomWindowPosition
                    )),
                        (d.externalContainerWidth = d.externalContainer.width()),
                        (d.externalContainerHeight = d.externalContainer.height()),
                        (d.externalContainerOffset = d.externalContainer.offset()),
                        (d.windowOffsetTop = d.externalContainerOffset.top),
                        (d.windowOffsetLeft = d.externalContainerOffset.left);
                } else {
                    switch (d.options.zoomWindowPosition) {
                        case 1:
                            (d.windowOffsetTop = d.options.zoomWindowOffety),
                                (d.windowOffsetLeft = +d.nzWidth);
                            break;
                        case 2:
                            d.options.zoomWindowHeight > d.nzHeight &&
                                ((d.windowOffsetTop =
                                    -1 *
                                    (d.options.zoomWindowHeight / 2 -
                                        d.nzHeight / 2)),
                                (d.windowOffsetLeft = d.nzWidth));
                            break;
                        case 3:
                            (d.windowOffsetTop =
                                d.nzHeight -
                                d.zoomWindow.height() -
                                2 * d.options.borderSize),
                                (d.windowOffsetLeft = d.nzWidth);
                            break;
                        case 4:
                            (d.windowOffsetTop = d.nzHeight),
                                (d.windowOffsetLeft = d.nzWidth);
                            break;
                        case 5:
                            (d.windowOffsetTop = d.nzHeight),
                                (d.windowOffsetLeft =
                                    d.nzWidth -
                                    d.zoomWindow.width() -
                                    2 * d.options.borderSize);
                            break;
                        case 6:
                            d.options.zoomWindowHeight > d.nzHeight &&
                                ((d.windowOffsetTop = d.nzHeight),
                                (d.windowOffsetLeft =
                                    -1 *
                                    (d.options.zoomWindowWidth / 2 -
                                        d.nzWidth / 2 +
                                        2 * d.options.borderSize)));
                            break;
                        case 7:
                            (d.windowOffsetTop = d.nzHeight),
                                (d.windowOffsetLeft = 0);
                            break;
                        case 8:
                            (d.windowOffsetTop = d.nzHeight),
                                (d.windowOffsetLeft =
                                    -1 *
                                    (d.zoomWindow.width() +
                                        2 * d.options.borderSize));
                            break;
                        case 9:
                            (d.windowOffsetTop =
                                d.nzHeight -
                                d.zoomWindow.height() -
                                2 * d.options.borderSize),
                                (d.windowOffsetLeft =
                                    -1 *
                                    (d.zoomWindow.width() +
                                        2 * d.options.borderSize));
                            break;
                        case 10:
                            d.options.zoomWindowHeight > d.nzHeight &&
                                ((d.windowOffsetTop =
                                    -1 *
                                    (d.options.zoomWindowHeight / 2 -
                                        d.nzHeight / 2)),
                                (d.windowOffsetLeft =
                                    -1 *
                                    (d.zoomWindow.width() +
                                        2 * d.options.borderSize)));
                            break;
                        case 11:
                            (d.windowOffsetTop = d.options.zoomWindowOffety),
                                (d.windowOffsetLeft =
                                    -1 *
                                    (d.zoomWindow.width() +
                                        2 * d.options.borderSize));
                            break;
                        case 12:
                            (d.windowOffsetTop =
                                -1 *
                                (d.zoomWindow.height() +
                                    2 * d.options.borderSize)),
                                (d.windowOffsetLeft =
                                    -1 *
                                    (d.zoomWindow.width() +
                                        2 * d.options.borderSize));
                            break;
                        case 13:
                            (d.windowOffsetTop =
                                -1 *
                                (d.zoomWindow.height() +
                                    2 * d.options.borderSize)),
                                (d.windowOffsetLeft = 0);
                            break;
                        case 14:
                            d.options.zoomWindowHeight > d.nzHeight &&
                                ((d.windowOffsetTop =
                                    -1 *
                                    (d.zoomWindow.height() +
                                        2 * d.options.borderSize)),
                                (d.windowOffsetLeft =
                                    -1 *
                                    (d.options.zoomWindowWidth / 2 -
                                        d.nzWidth / 2 +
                                        2 * d.options.borderSize)));
                            break;
                        case 15:
                            (d.windowOffsetTop =
                                -1 *
                                (d.zoomWindow.height() +
                                    2 * d.options.borderSize)),
                                (d.windowOffsetLeft =
                                    d.nzWidth -
                                    d.zoomWindow.width() -
                                    2 * d.options.borderSize);
                            break;
                        case 16:
                            (d.windowOffsetTop =
                                -1 *
                                (d.zoomWindow.height() +
                                    2 * d.options.borderSize)),
                                (d.windowOffsetLeft = d.nzWidth);
                            break;
                        default:
                            (d.windowOffsetTop = d.options.zoomWindowOffety),
                                (d.windowOffsetLeft = d.nzWidth);
                    }
                }
                (d.isWindowSet = !0),
                    (d.windowOffsetTop += d.options.zoomWindowOffety),
                    (d.windowOffsetLeft += d.options.zoomWindowOffetx),
                    d.zoomWindow.css({ top: d.windowOffsetTop }),
                    d.zoomWindow.css({ left: d.windowOffsetLeft }),
                    "inner" == d.options.zoomType &&
                        (d.zoomWindow.css({ top: 0 }),
                        d.zoomWindow.css({ left: 0 })),
                    (d.windowLeftPos = String(
                        -1 *
                            ((a.pageX - d.nzOffset.left) * d.widthRatio -
                                d.zoomWindow.width() / 2)
                    )),
                    (d.windowTopPos = String(
                        -1 *
                            ((a.pageY - d.nzOffset.top) * d.heightRatio -
                                d.zoomWindow.height() / 2)
                    )),
                    d.Etoppos && (d.windowTopPos = 0),
                    d.Eloppos && (d.windowLeftPos = 0),
                    d.Eboppos &&
                        (d.windowTopPos =
                            -1 *
                            (d.largeHeight / d.currentZoomLevel -
                                d.zoomWindow.height())),
                    d.Eroppos &&
                        (d.windowLeftPos =
                            -1 *
                            (d.largeWidth / d.currentZoomLevel -
                                d.zoomWindow.width())),
                    d.fullheight && (d.windowTopPos = 0),
                    d.fullwidth && (d.windowLeftPos = 0),
                    ("window" != d.options.zoomType &&
                        "inner" != d.options.zoomType) ||
                        (1 == d.zoomLock &&
                            (1 >= d.widthRatio && (d.windowLeftPos = 0),
                            1 >= d.heightRatio && (d.windowTopPos = 0)),
                        d.largeHeight < d.options.zoomWindowHeight &&
                            (d.windowTopPos = 0),
                        d.largeWidth < d.options.zoomWindowWidth &&
                            (d.windowLeftPos = 0),
                        d.options.easing
                            ? (d.xp || (d.xp = 0),
                              d.yp || (d.yp = 0),
                              d.loop ||
                                  (d.loop = setInterval(function () {
                                      (d.xp +=
                                          (d.windowLeftPos - d.xp) /
                                          d.options.easingAmount),
                                          (d.yp +=
                                              (d.windowTopPos - d.yp) /
                                              d.options.easingAmount),
                                          d.scrollingLock
                                              ? (clearInterval(d.loop),
                                                (d.xp = d.windowLeftPos),
                                                (d.yp = d.windowTopPos),
                                                (d.xp =
                                                    -1 *
                                                    ((a.pageX -
                                                        d.nzOffset.left) *
                                                        d.widthRatio -
                                                        d.zoomWindow.width() /
                                                            2)),
                                                (d.yp =
                                                    -1 *
                                                    ((a.pageY -
                                                        d.nzOffset.top) *
                                                        d.heightRatio -
                                                        d.zoomWindow.height() /
                                                            2)),
                                                d.changeBgSize &&
                                                    (d.nzHeight > d.nzWidth
                                                        ? ("lens" ==
                                                              d.options
                                                                  .zoomType &&
                                                              d.zoomLens.css({
                                                                  "background-size":
                                                                      d.largeWidth /
                                                                          d.newvalueheight +
                                                                      "px " +
                                                                      d.largeHeight /
                                                                          d.newvalueheight +
                                                                      "px",
                                                              }),
                                                          d.zoomWindow.css({
                                                              "background-size":
                                                                  d.largeWidth /
                                                                      d.newvalueheight +
                                                                  "px " +
                                                                  d.largeHeight /
                                                                      d.newvalueheight +
                                                                  "px",
                                                          }))
                                                        : ("lens" !=
                                                              d.options
                                                                  .zoomType &&
                                                              d.zoomLens.css({
                                                                  "background-size":
                                                                      d.largeWidth /
                                                                          d.newvaluewidth +
                                                                      "px " +
                                                                      d.largeHeight /
                                                                          d.newvalueheight +
                                                                      "px",
                                                              }),
                                                          d.zoomWindow.css({
                                                              "background-size":
                                                                  d.largeWidth /
                                                                      d.newvaluewidth +
                                                                  "px " +
                                                                  d.largeHeight /
                                                                      d.newvaluewidth +
                                                                  "px",
                                                          })),
                                                    (d.changeBgSize = !1)),
                                                d.zoomWindow.css({
                                                    backgroundPosition:
                                                        d.windowLeftPos +
                                                        "px " +
                                                        d.windowTopPos +
                                                        "px",
                                                }),
                                                (d.scrollingLock = !1),
                                                (d.loop = !1))
                                              : (d.changeBgSize &&
                                                    (d.nzHeight > d.nzWidth
                                                        ? ("lens" ==
                                                              d.options
                                                                  .zoomType &&
                                                              d.zoomLens.css({
                                                                  "background-size":
                                                                      d.largeWidth /
                                                                          d.newvalueheight +
                                                                      "px " +
                                                                      d.largeHeight /
                                                                          d.newvalueheight +
                                                                      "px",
                                                              }),
                                                          d.zoomWindow.css({
                                                              "background-size":
                                                                  d.largeWidth /
                                                                      d.newvalueheight +
                                                                  "px " +
                                                                  d.largeHeight /
                                                                      d.newvalueheight +
                                                                  "px",
                                                          }))
                                                        : ("lens" !=
                                                              d.options
                                                                  .zoomType &&
                                                              d.zoomLens.css({
                                                                  "background-size":
                                                                      d.largeWidth /
                                                                          d.newvaluewidth +
                                                                      "px " +
                                                                      d.largeHeight /
                                                                          d.newvaluewidth +
                                                                      "px",
                                                              }),
                                                          d.zoomWindow.css({
                                                              "background-size":
                                                                  d.largeWidth /
                                                                      d.newvaluewidth +
                                                                  "px " +
                                                                  d.largeHeight /
                                                                      d.newvaluewidth +
                                                                  "px",
                                                          })),
                                                    (d.changeBgSize = !1)),
                                                d.zoomWindow.css({
                                                    backgroundPosition:
                                                        d.xp +
                                                        "px " +
                                                        d.yp +
                                                        "px",
                                                }));
                                  }, 16)))
                            : (d.changeBgSize &&
                                  (d.nzHeight > d.nzWidth
                                      ? ("lens" == d.options.zoomType &&
                                            d.zoomLens.css({
                                                "background-size":
                                                    d.largeWidth /
                                                        d.newvalueheight +
                                                    "px " +
                                                    d.largeHeight /
                                                        d.newvalueheight +
                                                    "px",
                                            }),
                                        d.zoomWindow.css({
                                            "background-size":
                                                d.largeWidth /
                                                    d.newvalueheight +
                                                "px " +
                                                d.largeHeight /
                                                    d.newvalueheight +
                                                "px",
                                        }))
                                      : ("lens" == d.options.zoomType &&
                                            d.zoomLens.css({
                                                "background-size":
                                                    d.largeWidth /
                                                        d.newvaluewidth +
                                                    "px " +
                                                    d.largeHeight /
                                                        d.newvaluewidth +
                                                    "px",
                                            }),
                                        d.largeHeight / d.newvaluewidth <
                                        d.options.zoomWindowHeight
                                            ? d.zoomWindow.css({
                                                  "background-size":
                                                      d.largeWidth /
                                                          d.newvaluewidth +
                                                      "px " +
                                                      d.largeHeight /
                                                          d.newvaluewidth +
                                                      "px",
                                              })
                                            : d.zoomWindow.css({
                                                  "background-size":
                                                      d.largeWidth /
                                                          d.newvalueheight +
                                                      "px " +
                                                      d.largeHeight /
                                                          d.newvalueheight +
                                                      "px",
                                              })),
                                  (d.changeBgSize = !1)),
                              d.zoomWindow.css({
                                  backgroundPosition:
                                      d.windowLeftPos +
                                      "px " +
                                      d.windowTopPos +
                                      "px",
                              })));
            },
            setTintPosition: function (b) {
                (this.nzOffset = this.$elem.offset()),
                    (this.tintpos = String(
                        -1 *
                            (b.pageX -
                                this.nzOffset.left -
                                this.zoomLens.width() / 2)
                    )),
                    (this.tintposy = String(
                        -1 *
                            (b.pageY -
                                this.nzOffset.top -
                                this.zoomLens.height() / 2)
                    )),
                    this.Etoppos && (this.tintposy = 0),
                    this.Eloppos && (this.tintpos = 0),
                    this.Eboppos &&
                        (this.tintposy =
                            -1 *
                            (this.nzHeight -
                                this.zoomLens.height() -
                                2 * this.options.lensBorderSize)),
                    this.Eroppos &&
                        (this.tintpos =
                            -1 *
                            (this.nzWidth -
                                this.zoomLens.width() -
                                2 * this.options.lensBorderSize)),
                    this.options.tint &&
                        (this.fullheight && (this.tintposy = 0),
                        this.fullwidth && (this.tintpos = 0),
                        this.zoomTintImage.css({ left: this.tintpos + "px" }),
                        this.zoomTintImage.css({ top: this.tintposy + "px" }));
            },
            swaptheimage: function (a, m) {
                var l = this,
                    k = new Image();
                l.options.loadingIcon &&
                    ((l.spinner = g(
                        "<div style=\"background: url('" +
                            l.options.loadingIcon +
                            "') no-repeat center;height:" +
                            l.nzHeight +
                            "px;width:" +
                            l.nzWidth +
                            'px;z-index: 2000;position: absolute; background-position: center center;"></div>'
                    )),
                    l.$elem.after(l.spinner)),
                    l.options.onImageSwap(l.$elem),
                    (k.onload = function () {
                        (l.largeWidth = k.width),
                            (l.largeHeight = k.height),
                            (l.zoomImage = m),
                            l.zoomWindow.css({
                                "background-size":
                                    l.largeWidth + "px " + l.largeHeight + "px",
                            }),
                            l.zoomWindow.css({
                                "background-size":
                                    l.largeWidth + "px " + l.largeHeight + "px",
                            }),
                            l.swapAction(a, m);
                    }),
                    (k.src = m);
            },
            swapAction: function (a, o) {
                var n = this,
                    m = new Image();
                if (
                    ((m.onload = function () {
                        (n.nzHeight = m.height),
                            (n.nzWidth = m.width),
                            n.options.onImageSwapComplete(n.$elem),
                            n.doneCallback();
                    }),
                    (m.src = a),
                    (n.currentZoomLevel = n.options.zoomLevel),
                    (n.options.maxZoomLevel = !1),
                    "lens" == n.options.zoomType &&
                        n.zoomLens.css({ backgroundImage: "url('" + o + "')" }),
                    "window" == n.options.zoomType &&
                        n.zoomWindow.css({
                            backgroundImage: "url('" + o + "')",
                        }),
                    "inner" == n.options.zoomType &&
                        n.zoomWindow.css({
                            backgroundImage: "url('" + o + "')",
                        }),
                    (n.currentImage = o),
                    n.options.imageCrossfade)
                ) {
                    var l = n.$elem,
                        k = l.clone();
                    n.$elem.attr("src", a),
                        n.$elem.after(k),
                        k
                            .stop(!0)
                            .fadeOut(n.options.imageCrossfade, function () {
                                g(this).remove();
                            }),
                        n.$elem.width("auto").removeAttr("width"),
                        n.$elem.height("auto").removeAttr("height"),
                        l.fadeIn(n.options.imageCrossfade),
                        n.options.tint &&
                            "inner" != n.options.zoomType &&
                            ((l = n.zoomTintImage),
                            (k = l.clone()),
                            n.zoomTintImage.attr("src", o),
                            n.zoomTintImage.after(k),
                            k
                                .stop(!0)
                                .fadeOut(n.options.imageCrossfade, function () {
                                    g(this).remove();
                                }),
                            l.fadeIn(n.options.imageCrossfade),
                            n.zoomTint.css({ height: n.$elem.height() }),
                            n.zoomTint.css({ width: n.$elem.width() })),
                        n.zoomContainer.css("height", n.$elem.height()),
                        n.zoomContainer.css("width", n.$elem.width()),
                        "inner" != n.options.zoomType ||
                            n.options.constrainType ||
                            (n.zoomWrap
                                .parent()
                                .css("height", n.$elem.height()),
                            n.zoomWrap.parent().css("width", n.$elem.width()),
                            n.zoomWindow.css("height", n.$elem.height()),
                            n.zoomWindow.css("width", n.$elem.width()));
                } else {
                    n.$elem.attr("src", a),
                        n.options.tint &&
                            (n.zoomTintImage.attr("src", o),
                            n.zoomTintImage.attr("height", n.$elem.height()),
                            n.zoomTintImage.css({ height: n.$elem.height() }),
                            n.zoomTint.css({ height: n.$elem.height() })),
                        n.zoomContainer.css("height", n.$elem.height()),
                        n.zoomContainer.css("width", n.$elem.width());
                }
                n.options.imageCrossfade &&
                    (n.zoomWrap.css("height", n.$elem.height()),
                    n.zoomWrap.css("width", n.$elem.width())),
                    n.options.constrainType &&
                        ("height" == n.options.constrainType &&
                            (n.zoomContainer.css(
                                "height",
                                n.options.constrainSize
                            ),
                            n.zoomContainer.css("width", "auto"),
                            n.options.imageCrossfade
                                ? (n.zoomWrap.css(
                                      "height",
                                      n.options.constrainSize
                                  ),
                                  n.zoomWrap.css("width", "auto"),
                                  (n.constwidth = n.zoomWrap.width()))
                                : (n.$elem.css(
                                      "height",
                                      n.options.constrainSize
                                  ),
                                  n.$elem.css("width", "auto"),
                                  (n.constwidth = n.$elem.width())),
                            "inner" == n.options.zoomType &&
                                (n.zoomWrap
                                    .parent()
                                    .css("height", n.options.constrainSize),
                                n.zoomWrap.parent().css("width", n.constwidth),
                                n.zoomWindow.css(
                                    "height",
                                    n.options.constrainSize
                                ),
                                n.zoomWindow.css("width", n.constwidth)),
                            n.options.tint &&
                                (n.tintContainer.css(
                                    "height",
                                    n.options.constrainSize
                                ),
                                n.tintContainer.css("width", n.constwidth),
                                n.zoomTint.css(
                                    "height",
                                    n.options.constrainSize
                                ),
                                n.zoomTint.css("width", n.constwidth),
                                n.zoomTintImage.css(
                                    "height",
                                    n.options.constrainSize
                                ),
                                n.zoomTintImage.css("width", n.constwidth))),
                        "width" == n.options.constrainType &&
                            (n.zoomContainer.css("height", "auto"),
                            n.zoomContainer.css(
                                "width",
                                n.options.constrainSize
                            ),
                            n.options.imageCrossfade
                                ? (n.zoomWrap.css("height", "auto"),
                                  n.zoomWrap.css(
                                      "width",
                                      n.options.constrainSize
                                  ),
                                  (n.constheight = n.zoomWrap.height()))
                                : (n.$elem.css("height", "auto"),
                                  n.$elem.css("width", n.options.constrainSize),
                                  (n.constheight = n.$elem.height())),
                            "inner" == n.options.zoomType &&
                                (n.zoomWrap
                                    .parent()
                                    .css("height", n.constheight),
                                n.zoomWrap
                                    .parent()
                                    .css("width", n.options.constrainSize),
                                n.zoomWindow.css("height", n.constheight),
                                n.zoomWindow.css(
                                    "width",
                                    n.options.constrainSize
                                )),
                            n.options.tint &&
                                (n.tintContainer.css("height", n.constheight),
                                n.tintContainer.css(
                                    "width",
                                    n.options.constrainSize
                                ),
                                n.zoomTint.css("height", n.constheight),
                                n.zoomTint.css(
                                    "width",
                                    n.options.constrainSize
                                ),
                                n.zoomTintImage.css("height", n.constheight),
                                n.zoomTintImage.css(
                                    "width",
                                    n.options.constrainSize
                                ))));
            },
            doneCallback: function () {
                this.options.loadingIcon && this.spinner.hide(),
                    (this.nzOffset = this.$elem.offset()),
                    (this.nzWidth = this.$elem.width()),
                    (this.nzHeight = this.$elem.height()),
                    (this.currentZoomLevel = this.options.zoomLevel),
                    (this.widthRatio = this.largeWidth / this.nzWidth),
                    (this.heightRatio = this.largeHeight / this.nzHeight),
                    "window" == this.options.zoomType &&
                        ((lensHeight =
                            this.nzHeight <
                            this.options.zoomWindowWidth / this.widthRatio
                                ? this.nzHeight
                                : String(
                                      this.options.zoomWindowHeight /
                                          this.heightRatio
                                  )),
                        (lensWidth =
                            this.options.zoomWindowWidth <
                            this.options.zoomWindowWidth
                                ? this.nzWidth
                                : this.options.zoomWindowWidth /
                                  this.widthRatio),
                        this.zoomLens &&
                            (this.zoomLens.css("width", lensWidth),
                            this.zoomLens.css("height", lensHeight)));
            },
            getCurrentImage: function () {
                return this.zoomImage;
            },
            getGalleryList: function () {
                var a = this;
                return (
                    (a.gallerylist = []),
                    a.options.gallery
                        ? g("#" + a.options.gallery + " a").each(function () {
                              var b = "";
                              g(this).data("zoom-image")
                                  ? (b = g(this).data("zoom-image"))
                                  : g(this).data("image") &&
                                    (b = g(this).data("image")),
                                  b == a.zoomImage
                                      ? a.gallerylist.unshift({
                                            href: "" + b,
                                            title: g(this)
                                                .find("img")
                                                .attr("title"),
                                        })
                                      : a.gallerylist.push({
                                            href: "" + b,
                                            title: g(this)
                                                .find("img")
                                                .attr("title"),
                                        });
                          })
                        : a.gallerylist.push({
                              href: "" + a.zoomImage,
                              title: g(this).find("img").attr("title"),
                          }),
                    console.log(a.gallerylist),
                    a.gallerylist
                );
            },
            changeZoomLevel: function (b) {
                (this.scrollingLock = !0),
                    (this.newvalue = parseFloat(b).toFixed(2)),
                    (newvalue = parseFloat(b).toFixed(2)),
                    (maxheightnewvalue =
                        this.largeHeight /
                        ((this.options.zoomWindowHeight / this.nzHeight) *
                            this.nzHeight)),
                    (maxwidthtnewvalue =
                        this.largeWidth /
                        ((this.options.zoomWindowWidth / this.nzWidth) *
                            this.nzWidth)),
                    "inner" != this.options.zoomType &&
                        (maxheightnewvalue <= newvalue
                            ? ((this.heightRatio =
                                  this.largeHeight /
                                  maxheightnewvalue /
                                  this.nzHeight),
                              (this.newvalueheight = maxheightnewvalue),
                              (this.fullheight = !0))
                            : ((this.heightRatio =
                                  this.largeHeight / newvalue / this.nzHeight),
                              (this.newvalueheight = newvalue),
                              (this.fullheight = !1)),
                        maxwidthtnewvalue <= newvalue
                            ? ((this.widthRatio =
                                  this.largeWidth /
                                  maxwidthtnewvalue /
                                  this.nzWidth),
                              (this.newvaluewidth = maxwidthtnewvalue),
                              (this.fullwidth = !0))
                            : ((this.widthRatio =
                                  this.largeWidth / newvalue / this.nzWidth),
                              (this.newvaluewidth = newvalue),
                              (this.fullwidth = !1)),
                        "lens" == this.options.zoomType &&
                            (maxheightnewvalue <= newvalue
                                ? ((this.fullwidth = !0),
                                  (this.newvaluewidth = maxheightnewvalue))
                                : ((this.widthRatio =
                                      this.largeWidth /
                                      newvalue /
                                      this.nzWidth),
                                  (this.newvaluewidth = newvalue),
                                  (this.fullwidth = !1)))),
                    "inner" == this.options.zoomType &&
                        ((maxheightnewvalue = parseFloat(
                            this.largeHeight / this.nzHeight
                        ).toFixed(2)),
                        (maxwidthtnewvalue = parseFloat(
                            this.largeWidth / this.nzWidth
                        ).toFixed(2)),
                        newvalue > maxheightnewvalue &&
                            (newvalue = maxheightnewvalue),
                        newvalue > maxwidthtnewvalue &&
                            (newvalue = maxwidthtnewvalue),
                        maxheightnewvalue <= newvalue
                            ? ((this.heightRatio =
                                  this.largeHeight / newvalue / this.nzHeight),
                              (this.newvalueheight =
                                  newvalue > maxheightnewvalue
                                      ? maxheightnewvalue
                                      : newvalue),
                              (this.fullheight = !0))
                            : ((this.heightRatio =
                                  this.largeHeight / newvalue / this.nzHeight),
                              (this.newvalueheight =
                                  newvalue > maxheightnewvalue
                                      ? maxheightnewvalue
                                      : newvalue),
                              (this.fullheight = !1)),
                        maxwidthtnewvalue <= newvalue
                            ? ((this.widthRatio =
                                  this.largeWidth / newvalue / this.nzWidth),
                              (this.newvaluewidth =
                                  newvalue > maxwidthtnewvalue
                                      ? maxwidthtnewvalue
                                      : newvalue),
                              (this.fullwidth = !0))
                            : ((this.widthRatio =
                                  this.largeWidth / newvalue / this.nzWidth),
                              (this.newvaluewidth = newvalue),
                              (this.fullwidth = !1))),
                    (scrcontinue = !1),
                    "inner" == this.options.zoomType &&
                        (this.nzWidth > this.nzHeight &&
                            (this.newvaluewidth <= maxwidthtnewvalue
                                ? (scrcontinue = !0)
                                : ((scrcontinue = !1),
                                  (this.fullwidth = this.fullheight = !0))),
                        this.nzHeight > this.nzWidth &&
                            (this.newvaluewidth <= maxwidthtnewvalue
                                ? (scrcontinue = !0)
                                : ((scrcontinue = !1),
                                  (this.fullwidth = this.fullheight = !0)))),
                    "inner" != this.options.zoomType && (scrcontinue = !0),
                    scrcontinue &&
                        ((this.zoomLock = 0),
                        (this.changeZoom = !0),
                        this.options.zoomWindowHeight / this.heightRatio <=
                            this.nzHeight &&
                            ((this.currentZoomLevel = this.newvalueheight),
                            "lens" != this.options.zoomType &&
                                "inner" != this.options.zoomType &&
                                ((this.changeBgSize = !0),
                                this.zoomLens.css({
                                    height:
                                        String(
                                            this.options.zoomWindowHeight /
                                                this.heightRatio
                                        ) + "px",
                                })),
                            "lens" == this.options.zoomType ||
                                "inner" == this.options.zoomType) &&
                            (this.changeBgSize = !0),
                        this.options.zoomWindowWidth / this.widthRatio <=
                            this.nzWidth &&
                            ("inner" != this.options.zoomType &&
                                this.newvaluewidth > this.newvalueheight &&
                                (this.currentZoomLevel = this.newvaluewidth),
                            "lens" != this.options.zoomType &&
                                "inner" != this.options.zoomType &&
                                ((this.changeBgSize = !0),
                                this.zoomLens.css({
                                    width:
                                        String(
                                            this.options.zoomWindowWidth /
                                                this.widthRatio
                                        ) + "px",
                                })),
                            "lens" == this.options.zoomType ||
                                "inner" == this.options.zoomType) &&
                            (this.changeBgSize = !0),
                        "inner" == this.options.zoomType &&
                            ((this.changeBgSize = !0),
                            this.nzWidth > this.nzHeight &&
                                (this.currentZoomLevel = this.newvaluewidth),
                            this.nzHeight > this.nzWidth &&
                                (this.currentZoomLevel = this.newvaluewidth))),
                    this.setPosition(this.currentLoc);
            },
            closeAll: function () {
                self.zoomWindow && self.zoomWindow.hide(),
                    self.zoomLens && self.zoomLens.hide(),
                    self.zoomTint && self.zoomTint.hide();
            },
            changeState: function (b) {
                "enable" == b && (this.options.zoomEnabled = !0),
                    "disable" == b && (this.options.zoomEnabled = !1);
            },
        };
        (g.fn.elevateZoom = function (a) {
            return this.each(function () {
                var b = Object.create(h);
                b.init(a, this), g.data(this, "elevateZoom", b);
            });
        }),
            (g.fn.elevateZoom.options = {
                zoomActivation: "hover",
                zoomEnabled: !0,
                preloading: 1,
                zoomLevel: 1,
                scrollZoom: !1,
                scrollZoomIncrement: 0.1,
                minZoomLevel: !1,
                maxZoomLevel: !1,
                easing: !1,
                easingAmount: 12,
                lensSize: 200,
                zoomWindowWidth: 400,
                zoomWindowHeight: 400,
                zoomWindowOffetx: 0,
                zoomWindowOffety: 0,
                zoomWindowPosition: 1,
                zoomWindowBgColour: "#fff",
                lensFadeIn: !1,
                lensFadeOut: !1,
                debug: !1,
                zoomWindowFadeIn: !1,
                zoomWindowFadeOut: !1,
                zoomWindowAlwaysShow: !1,
                zoomTintFadeIn: !1,
                zoomTintFadeOut: !1,
                borderSize: 4,
                showLens: !0,
                borderColour: "#888",
                lensBorderSize: 1,
                lensBorderColour: "#000",
                lensShape: "square",
                zoomType: "window",
                containLensZoom: !1,
                lensColour: "white",
                lensOpacity: 0.4,
                lenszoom: !1,
                tint: !1,
                tintColour: "#333",
                tintOpacity: 0.4,
                gallery: !1,
                galleryActiveClass: "zoomGalleryActive",
                imageCrossfade: !1,
                constrainType: !1,
                constrainSize: !1,
                loadingIcon: !1,
                cursor: "default",
                responsive: !0,
                onComplete: g.noop,
                onZoomedImageLoaded: function () {},
                onImageSwap: g.noop,
                onImageSwapComplete: g.noop,
            });
    })(jQuery, window, document),
    !(function (F, E, D, C) {
        var B = D("html"),
            A = D(F),
            z = D(E),
            y = (D.fancyboxY = function () {
                y.open.apply(this, arguments);
            }),
            x = navigator.userAgent.match(/msie/i),
            w = null,
            v = E.createTouch !== C,
            u = function (b) {
                return b && b.hasOwnProperty && b instanceof D;
            },
            t = function (b) {
                return b && "string" === D.type(b);
            },
            s = function (b) {
                return t(b) && 0 < b.indexOf("%");
            },
            r = function (e, d) {
                var f = parseInt(e, 10) || 0;
                return (
                    d && s(e) && (f *= y.getViewport()[d] / 100), Math.ceil(f)
                );
            },
            q = function (d, c) {
                return r(d, c) + "px";
            };
        D.extend(y, {
            version: "2.1.5",
            defaults: {
                padding: 15,
                margin: 20,
                width: 800,
                height: 600,
                minWidth: 100,
                minHeight: 100,
                maxWidth: 9999,
                maxHeight: 9999,
                pixelRatio: 1,
                autoSize: !0,
                autoHeight: !1,
                autoWidth: !1,
                autoResize: !0,
                autoCenter: !v,
                fitToView: !0,
                aspectRatio: !1,
                topRatio: 0.5,
                leftRatio: 0.5,
                scrolling: "auto",
                wrapCSS: "",
                arrows: !0,
                closeBtn: !0,
                closeClick: !1,
                nextClick: !1,
                mouseWheel: !0,
                autoPlay: !1,
                playSpeed: 3000,
                preload: 3,
                modal: !1,
                loop: !0,
                ajax: { dataType: "html", headers: { "X-fancyBox": !0 } },
                iframe: { scrolling: "auto", preload: !0 },
                swf: {
                    wmode: "transparent",
                    allowfullscreen: "true",
                    allowscriptaccess: "always",
                },
                keys: {
                    next: { 13: "left", 34: "up", 39: "left", 40: "up" },
                    prev: { 8: "right", 33: "down", 37: "right", 38: "down" },
                    close: [27],
                    play: [32],
                    toggle: [70],
                },
                direction: { next: "left", prev: "right" },
                scrollOutside: !0,
                index: 0,
                type: null,
                href: null,
                content: null,
                title: null,
                tpl: {
                    wrap:
                        '<div class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                    image: '<img class="fancybox-image" src="{href}" alt="" />',
                    iframe:
                        '<iframe id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" frameborder="0" vspace="0" hspace="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen' +
                        (x ? ' allowtransparency="true"' : "") +
                        "></iframe>",
                    error:
                        '<p class="fancybox-error">The requested content cannot be loaded.<br/>Please try again later.</p>',
                    closeBtn:
                        '<a title="Close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                    next:
                        '<a title="Next" class="fancybox-nav fancybox-next" href="javascript:;"><span></span></a>',
                    prev:
                        '<a title="Previous" class="fancybox-nav fancybox-prev" href="javascript:;"><span></span></a>',
                },
                openEffect: "fade",
                openSpeed: 250,
                openEasing: "swing",
                openOpacity: !0,
                openMethod: "zoomIn",
                closeEffect: "fade",
                closeSpeed: 250,
                closeEasing: "swing",
                closeOpacity: !0,
                closeMethod: "zoomOut",
                nextEffect: "elastic",
                nextSpeed: 250,
                nextEasing: "swing",
                nextMethod: "changeIn",
                prevEffect: "elastic",
                prevSpeed: 250,
                prevEasing: "swing",
                prevMethod: "changeOut",
                helpers: { overlay: !0, title: !0 },
                onCancel: D.noop,
                beforeLoad: D.noop,
                afterLoad: D.noop,
                beforeShow: D.noop,
                afterShow: D.noop,
                beforeChange: D.noop,
                beforeClose: D.noop,
                afterClose: D.noop,
            },
            group: {},
            opts: {},
            previous: null,
            coming: null,
            current: null,
            isActive: !1,
            isOpen: !1,
            isOpened: !1,
            wrap: null,
            skin: null,
            outer: null,
            inner: null,
            player: { timer: null, isActive: !1 },
            ajaxLoad: null,
            imgPreload: null,
            transitions: {},
            helpers: {},
            open: function (d, c) {
                if (d && (D.isPlainObject(c) || (c = {}), !1 !== y.close(!0))) {
                    return (
                        D.isArray(d) || (d = u(d) ? D(d).get() : [d]),
                        D.each(d, function (p, m) {
                            var l,
                                h,
                                b,
                                a,
                                H,
                                G = {};
                            "object" === D.type(m) &&
                                (m.nodeType && (m = D(m)),
                                u(m)
                                    ? ((G = {
                                          href:
                                              m.data("fancybox-href") ||
                                              m.attr("href"),
                                          title:
                                              m.data("fancybox-title") ||
                                              m.attr("title"),
                                          isDom: !0,
                                          element: m,
                                      }),
                                      D.metadata &&
                                          D.extend(!0, G, m.metadata()))
                                    : (G = m)),
                                (l = c.href || G.href || (t(m) ? m : null)),
                                (h = c.title !== C ? c.title : G.title || ""),
                                (a = (b = c.content || G.content)
                                    ? "html"
                                    : c.type || G.type),
                                !a &&
                                    G.isDom &&
                                    ((a = m.data("fancybox-type")),
                                    a ||
                                        (a = (a = m
                                            .prop("class")
                                            .match(/fancybox\.(\w+)/))
                                            ? a[1]
                                            : null)),
                                t(l) &&
                                    (a ||
                                        (y.isImage(l)
                                            ? (a = "image")
                                            : y.isSWF(l)
                                            ? (a = "swf")
                                            : "#" === l.charAt(0)
                                            ? (a = "inline")
                                            : t(m) && ((a = "html"), (b = m))),
                                    "ajax" === a &&
                                        ((H = l.split(/\s+/, 2)),
                                        (l = H.shift()),
                                        (H = H.shift()))),
                                b ||
                                    ("inline" === a
                                        ? l
                                            ? (b = D(
                                                  t(l)
                                                      ? l.replace(
                                                            /.*(?=#[^\s]+$)/,
                                                            ""
                                                        )
                                                      : l
                                              ))
                                            : G.isDom && (b = m)
                                        : "html" === a
                                        ? (b = l)
                                        : !a &&
                                          !l &&
                                          G.isDom &&
                                          ((a = "inline"), (b = m))),
                                D.extend(G, {
                                    href: l,
                                    type: a,
                                    content: b,
                                    title: h,
                                    selector: H,
                                }),
                                (d[p] = G);
                        }),
                        (y.opts = D.extend(!0, {}, y.defaults, c)),
                        c.keys !== C &&
                            (y.opts.keys =
                                !!c.keys &&
                                D.extend({}, y.defaults.keys, c.keys)),
                        (y.group = d),
                        y._start(y.opts.index)
                    );
                }
            },
            cancel: function () {
                var b = y.coming;
                b &&
                    !1 !== y.trigger("onCancel") &&
                    (y.hideLoading(),
                    y.ajaxLoad && y.ajaxLoad.abort(),
                    (y.ajaxLoad = null),
                    y.imgPreload &&
                        (y.imgPreload.onload = y.imgPreload.onerror = null),
                    b.wrap && b.wrap.stop(!0, !0).trigger("onReset").remove(),
                    (y.coming = null),
                    y.current || y._afterZoomOut(b));
            },
            close: function (b) {
                y.cancel(),
                    !1 !== y.trigger("beforeClose") &&
                        (y.unbindEvents(),
                        y.isActive &&
                            (y.isOpen && !0 !== b
                                ? ((y.isOpen = y.isOpened = !1),
                                  (y.isClosing = !0),
                                  D(".fancybox-item, .fancybox-nav").remove(),
                                  y.wrap
                                      .stop(!0, !0)
                                      .removeClass("fancybox-opened"),
                                  y.transitions[y.current.closeMethod]())
                                : (D(".fancybox-wrap")
                                      .stop(!0)
                                      .trigger("onReset")
                                      .remove(),
                                  y._afterZoomOut())));
            },
            play: function (f) {
                var e = function () {
                        clearTimeout(y.player.timer);
                    },
                    h = function () {
                        e(),
                            y.current &&
                                y.player.isActive &&
                                (y.player.timer = setTimeout(
                                    y.next,
                                    y.current.playSpeed
                                ));
                    },
                    g = function () {
                        e(),
                            z.unbind(".player"),
                            (y.player.isActive = !1),
                            y.trigger("onPlayEnd");
                    };
                !0 === f || (!y.player.isActive && !1 !== f)
                    ? y.current &&
                      (y.current.loop ||
                          y.current.index < y.group.length - 1) &&
                      ((y.player.isActive = !0),
                      z.bind({
                          "onCancel.player beforeClose.player": g,
                          "onUpdate.player": h,
                          "beforeLoad.player": e,
                      }),
                      h(),
                      y.trigger("onPlayStart"))
                    : g();
            },
            next: function (d) {
                var c = y.current;
                c &&
                    (t(d) || (d = c.direction.next),
                    y.jumpto(c.index + 1, d, "next"));
            },
            prev: function (d) {
                var c = y.current;
                c &&
                    (t(d) || (d = c.direction.prev),
                    y.jumpto(c.index - 1, d, "prev"));
            },
            jumpto: function (f, d, h) {
                var g = y.current;
                g &&
                    ((f = r(f)),
                    (y.direction =
                        d || g.direction[f >= g.index ? "next" : "prev"]),
                    (y.router = h || "jumpto"),
                    g.loop &&
                        (0 > f && (f = g.group.length + (f % g.group.length)),
                        (f %= g.group.length)),
                    g.group[f] !== C && (y.cancel(), y._start(f)));
            },
            reposition: function (g, c) {
                var j,
                    i = y.current,
                    h = i ? i.wrap : null;
                h &&
                    ((j = y._getPosition(c)),
                    g && "scroll" === g.type
                        ? (delete j.position, h.stop(!0, !0).animate(j, 200))
                        : (h.css(j), (i.pos = D.extend({}, i.dim, j))));
            },
            update: function (e) {
                var d = e && e.type,
                    f = !d || "orientationchange" === d;
                f && (clearTimeout(w), (w = null)),
                    y.isOpen &&
                        !w &&
                        (w = setTimeout(
                            function () {
                                var a = y.current;
                                a &&
                                    !y.isClosing &&
                                    (y.wrap.removeClass("fancybox-tmp"),
                                    (f ||
                                        "load" === d ||
                                        ("resize" === d && a.autoResize)) &&
                                        y._setDimension(),
                                    ("scroll" === d && a.canShrink) ||
                                        y.reposition(e),
                                    y.trigger("onUpdate"),
                                    (w = null));
                            },
                            f && !v ? 0 : 300
                        ));
            },
            toggle: function (b) {
                y.isOpen &&
                    ((y.current.fitToView =
                        "boolean" === D.type(b) ? b : !y.current.fitToView),
                    v &&
                        (y.wrap.removeAttr("style").addClass("fancybox-tmp"),
                        y.trigger("onUpdate")),
                    y.update());
            },
            hideLoading: function () {
                z.unbind(".loading"), D("#fancybox-loading").remove();
            },
            showLoading: function () {
                var d, c;
                y.hideLoading(),
                    (d = D('<div id="fancybox-loading"><div></div></div>')
                        .click(y.cancel)
                        .appendTo("body")),
                    z.bind("keydown.loading", function (b) {
                        27 === (b.which || b.keyCode) &&
                            (b.preventDefault(), y.cancel());
                    }),
                    y.defaults.fixed ||
                        ((c = y.getViewport()),
                        d.css({
                            position: "absolute",
                            top: 0,
                            left: 0.5 * c.w + c.x,
                        }));
            },
            getViewport: function () {
                var a = (y.current && y.current.locked) || !1,
                    d = { x: A.scrollLeft(), y: A.scrollTop() };
                return (
                    a
                        ? ((d.w = a[0].clientWidth), (d.h = a[0].clientHeight))
                        : ((d.w = v && F.innerWidth ? F.innerWidth : A.width()),
                          (d.h =
                              v && F.innerHeight ? F.innerHeight : A.height())),
                    d
                );
            },
            unbindEvents: function () {
                y.wrap && u(y.wrap) && y.wrap.unbind(".fb"),
                    z.unbind(".fb"),
                    A.unbind(".fb");
            },
            bindEvents: function () {
                var d,
                    c = y.current;
                c &&
                    (A.bind(
                        "orientationchange.fb" +
                            (v ? "" : " resize.fb") +
                            (c.autoCenter && !c.locked ? " scroll.fb" : ""),
                        y.update
                    ),
                    (d = c.keys) &&
                        z.bind("keydown.fb", function (h) {
                            var b = h.which || h.keyCode,
                                a = h.target || h.srcElement;
                            return (
                                (27 !== b || !y.coming) &&
                                void (
                                    !h.ctrlKey &&
                                    !h.altKey &&
                                    !h.shiftKey &&
                                    !h.metaKey &&
                                    (!a ||
                                        (!a.type &&
                                            !D(a).is("[contenteditable]"))) &&
                                    D.each(d, function (e, f) {
                                        return 1 < c.group.length && f[b] !== C
                                            ? (y[e](f[b]),
                                              h.preventDefault(),
                                              !1)
                                            : -1 < D.inArray(b, f)
                                            ? (y[e](), h.preventDefault(), !1)
                                            : void 0;
                                    })
                                )
                            );
                        }),
                    D.fn.mousewheel &&
                        c.mouseWheel &&
                        y.wrap.bind("mousewheel.fb", function (b, m, l, k) {
                            for (
                                var j = D(b.target || null), h = !1;
                                j.length &&
                                !h &&
                                !j.is(".fancybox-skin") &&
                                !j.is(".fancybox-wrap");

                            ) {
                                (h =
                                    j[0] &&
                                    !(
                                        j[0].style.overflow &&
                                        "hidden" === j[0].style.overflow
                                    ) &&
                                    ((j[0].clientWidth &&
                                        j[0].scrollWidth > j[0].clientWidth) ||
                                        (j[0].clientHeight &&
                                            j[0].scrollHeight >
                                                j[0].clientHeight))),
                                    (j = D(j).parent());
                            }
                            0 !== m &&
                                !h &&
                                1 < y.group.length &&
                                !c.canShrink &&
                                (0 < k || 0 < l
                                    ? y.prev(0 < k ? "down" : "left")
                                    : (0 > k || 0 > l) &&
                                      y.next(0 > k ? "up" : "right"),
                                b.preventDefault());
                        }));
            },
            trigger: function (f, c) {
                var h,
                    g = c || y.coming || y.current;
                if (g) {
                    if (
                        (D.isFunction(g[f]) &&
                            (h = g[f].apply(
                                g,
                                Array.prototype.slice.call(arguments, 1)
                            )),
                        !1 === h)
                    ) {
                        return !1;
                    }
                    g.helpers &&
                        D.each(g.helpers, function (a, e) {
                            e &&
                                y.helpers[a] &&
                                D.isFunction(y.helpers[a][f]) &&
                                y.helpers[a][f](
                                    D.extend(!0, {}, y.helpers[a].defaults, e),
                                    g
                                );
                        }),
                        z.trigger(f);
                }
            },
            isImage: function (b) {
                return (
                    t(b) &&
                    b.match(
                        /(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i
                    )
                );
            },
            isSWF: function (b) {
                return t(b) && b.match(/\.(swf)((\?|#).*)?$/i);
            },
            _start: function (f) {
                var c,
                    h,
                    g = {};
                if (((f = r(f)), (c = y.group[f] || null), !c)) {
                    return !1;
                }
                if (
                    ((g = D.extend(!0, {}, y.opts, c)),
                    (c = g.margin),
                    (h = g.padding),
                    "number" === D.type(c) && (g.margin = [c, c, c, c]),
                    "number" === D.type(h) && (g.padding = [h, h, h, h]),
                    g.modal &&
                        D.extend(!0, g, {
                            closeBtn: !1,
                            closeClick: !1,
                            nextClick: !1,
                            arrows: !1,
                            mouseWheel: !1,
                            keys: null,
                            helpers: { overlay: { closeClick: !1 } },
                        }),
                    g.autoSize && (g.autoWidth = g.autoHeight = !0),
                    "auto" === g.width && (g.autoWidth = !0),
                    "auto" === g.height && (g.autoHeight = !0),
                    (g.group = y.group),
                    (g.index = f),
                    (y.coming = g),
                    !1 === y.trigger("beforeLoad"))
                ) {
                    y.coming = null;
                } else {
                    if (((h = g.type), (c = g.href), !h)) {
                        return (
                            (y.coming = null),
                            !(
                                !y.current ||
                                !y.router ||
                                "jumpto" === y.router
                            ) &&
                                ((y.current.index = f),
                                y[y.router](y.direction))
                        );
                    }
                    if (
                        ((y.isActive = !0),
                        ("image" !== h && "swf" !== h) ||
                            ((g.autoHeight = g.autoWidth = !1),
                            (g.scrolling = "visible")),
                        "image" === h && (g.aspectRatio = !0),
                        "iframe" === h && v && (g.scrolling = "scroll"),
                        (g.wrap = D(g.tpl.wrap)
                            .addClass(
                                "fancybox-" +
                                    (v ? "mobile" : "desktop") +
                                    " fancybox-type-" +
                                    h +
                                    " fancybox-tmp " +
                                    g.wrapCSS
                            )
                            .appendTo(g.parent || "body")),
                        D.extend(g, {
                            skin: D(".fancybox-skin", g.wrap),
                            outer: D(".fancybox-outer", g.wrap),
                            inner: D(".fancybox-inner", g.wrap),
                        }),
                        D.each(
                            ["Top", "Right", "Bottom", "Left"],
                            function (e, d) {
                                g.skin.css("padding" + d, q(g.padding[e]));
                            }
                        ),
                        y.trigger("onReady"),
                        "inline" === h || "html" === h)
                    ) {
                        if (!g.content || !g.content.length) {
                            return y._error("content");
                        }
                    } else {
                        if (!c) {
                            return y._error("href");
                        }
                    }
                    "image" === h
                        ? y._loadImage()
                        : "ajax" === h
                        ? y._loadAjax()
                        : "iframe" === h
                        ? y._loadIframe()
                        : y._afterLoad();
                }
            },
            _error: function (b) {
                D.extend(y.coming, {
                    type: "html",
                    autoWidth: !0,
                    autoHeight: !0,
                    minWidth: 0,
                    minHeight: 0,
                    scrolling: "no",
                    hasError: b,
                    content: y.coming.tpl.error,
                }),
                    y._afterLoad();
            },
            _loadImage: function () {
                var b = (y.imgPreload = new Image());
                (b.onload = function () {
                    (this.onload = this.onerror = null),
                        (y.coming.width = this.width / y.opts.pixelRatio),
                        (y.coming.height = this.height / y.opts.pixelRatio),
                        y._afterLoad();
                }),
                    (b.onerror = function () {
                        (this.onload = this.onerror = null), y._error("image");
                    }),
                    (b.src = y.coming.href),
                    !0 !== b.complete && y.showLoading();
            },
            _loadAjax: function () {
                var b = y.coming;
                y.showLoading(),
                    (y.ajaxLoad = D.ajax(
                        D.extend({}, b.ajax, {
                            url: b.href,
                            error: function (d, c) {
                                y.coming && "abort" !== c
                                    ? y._error("ajax", d)
                                    : y.hideLoading();
                            },
                            success: function (a, d) {
                                "success" === d &&
                                    ((b.content = a), y._afterLoad());
                            },
                        })
                    ));
            },
            _loadIframe: function () {
                var d = y.coming,
                    c = D(
                        d.tpl.iframe.replace(/\{rnd\}/g, new Date().getTime())
                    )
                        .attr("scrolling", v ? "auto" : d.iframe.scrolling)
                        .attr("src", d.href);
                D(d.wrap).bind("onReset", function () {
                    try {
                        D(this)
                            .find("iframe")
                            .hide()
                            .attr("src", "//about:blank")
                            .end()
                            .empty();
                    } catch (b) {}
                }),
                    d.iframe.preload &&
                        (y.showLoading(),
                        c.one("load", function () {
                            D(this).data("ready", 1),
                                v || D(this).bind("load.fb", y.update),
                                D(this)
                                    .parents(".fancybox-wrap")
                                    .width("100%")
                                    .removeClass("fancybox-tmp")
                                    .show(),
                                y._afterLoad();
                        })),
                    (d.content = c.appendTo(d.inner)),
                    d.iframe.preload || y._afterLoad();
            },
            _preloadImages: function () {
                var h,
                    g,
                    l = y.group,
                    k = y.current,
                    j = l.length,
                    i = k.preload ? Math.min(k.preload, j - 1) : 0;
                for (g = 1; g <= i; g += 1) {
                    (h = l[(k.index + g) % j]),
                        "image" === h.type &&
                            h.href &&
                            (new Image().src = h.href);
                }
            },
            _afterLoad: function () {
                var h,
                    c,
                    n,
                    m,
                    l,
                    k = y.coming,
                    j = y.current;
                if ((y.hideLoading(), k && !1 !== y.isActive)) {
                    if (!1 === y.trigger("afterLoad", k, j)) {
                        k.wrap.stop(!0).trigger("onReset").remove(),
                            (y.coming = null);
                    } else {
                        switch (
                            (j &&
                                (y.trigger("beforeChange", j),
                                j.wrap
                                    .stop(!0)
                                    .removeClass("fancybox-opened")
                                    .find(".fancybox-item, .fancybox-nav")
                                    .remove()),
                            y.unbindEvents(),
                            (h = k.content),
                            (c = k.type),
                            (n = k.scrolling),
                            D.extend(y, {
                                wrap: k.wrap,
                                skin: k.skin,
                                outer: k.outer,
                                inner: k.inner,
                                current: k,
                                previous: j,
                            }),
                            (m = k.href),
                            c)
                        ) {
                            case "inline":
                            case "ajax":
                            case "html":
                                k.selector
                                    ? (h = D("<div>").html(h).find(k.selector))
                                    : u(h) &&
                                      (h.data("fancybox-placeholder") ||
                                          h.data(
                                              "fancybox-placeholder",
                                              D(
                                                  '<div class="fancybox-placeholder"></div>'
                                              )
                                                  .insertAfter(h)
                                                  .hide()
                                          ),
                                      (h = h.show().detach()),
                                      k.wrap.bind("onReset", function () {
                                          D(this).find(h).length &&
                                              h
                                                  .hide()
                                                  .replaceAll(
                                                      h.data(
                                                          "fancybox-placeholder"
                                                      )
                                                  )
                                                  .data(
                                                      "fancybox-placeholder",
                                                      !1
                                                  );
                                      }));
                                break;
                            case "image":
                                h = k.tpl.image.replace("{href}", m);
                                break;
                            case "swf":
                                (h =
                                    '<object id="fancybox-swf" classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" width="100%" height="100%"><param name="movie" value="' +
                                    m +
                                    '"></param>'),
                                    (l = ""),
                                    D.each(k.swf, function (a, d) {
                                        (h +=
                                            '<param name="' +
                                            a +
                                            '" value="' +
                                            d +
                                            '"></param>'),
                                            (l += " " + a + '="' + d + '"');
                                    }),
                                    (h +=
                                        '<embed src="' +
                                        m +
                                        '" type="application/x-shockwave-flash" width="100%" height="100%"' +
                                        l +
                                        "></embed></object>");
                        }
                        (!u(h) || !h.parent().is(k.inner)) && k.inner.append(h),
                            y.trigger("beforeShow"),
                            k.inner.css(
                                "overflow",
                                "yes" === n
                                    ? "scroll"
                                    : "no" === n
                                    ? "hidden"
                                    : n
                            ),
                            y._setDimension(),
                            y.reposition(),
                            (y.isOpen = !1),
                            (y.coming = null),
                            y.bindEvents(),
                            y.isOpened
                                ? j.prevMethod && y.transitions[j.prevMethod]()
                                : D(".fancybox-wrap")
                                      .not(k.wrap)
                                      .stop(!0)
                                      .trigger("onReset")
                                      .remove(),
                            y.transitions[
                                y.isOpened ? k.nextMethod : k.openMethod
                            ](),
                            y._preloadImages();
                    }
                }
            },
            _setDimension: function () {
                var aa,
                    Z,
                    Y,
                    X,
                    W,
                    V,
                    U,
                    T,
                    S,
                    R = y.getViewport(),
                    Q = 0,
                    O = !1,
                    M = !1,
                    O = y.wrap,
                    K = y.skin,
                    I = y.inner,
                    G = y.current,
                    M = G.width,
                    p = G.height,
                    o = G.minWidth,
                    n = G.minHeight,
                    h = G.maxWidth,
                    c = G.maxHeight,
                    P = G.scrolling,
                    N = G.scrollOutside ? G.scrollbarWidth : 0,
                    L = G.margin,
                    J = r(L[1] + L[3]),
                    H = r(L[0] + L[2]);
                if (
                    (O.add(K)
                        .add(I)
                        .width("auto")
                        .height("auto")
                        .removeClass("fancybox-tmp"),
                    (L = r(K.outerWidth(!0) - K.width())),
                    (aa = r(K.outerHeight(!0) - K.height())),
                    (Z = J + L),
                    (Y = H + aa),
                    (X = s(M) ? ((R.w - Z) * r(M)) / 100 : M),
                    (W = s(p) ? ((R.h - Y) * r(p)) / 100 : p),
                    "iframe" === G.type)
                ) {
                    if (
                        ((S = G.content), G.autoHeight && 1 === S.data("ready"))
                    ) {
                        try {
                            S[0].contentWindow.document.location &&
                                (I.width(X).height(9999),
                                (V = S.contents().find("body")),
                                N && V.css("overflow-x", "hidden"),
                                (W = V.outerHeight(!0)));
                        } catch (aa) {}
                    }
                } else {
                    (G.autoWidth || G.autoHeight) &&
                        (I.addClass("fancybox-tmp"),
                        G.autoWidth || I.width(X),
                        G.autoHeight || I.height(W),
                        G.autoWidth && (X = I.width()),
                        G.autoHeight && (W = I.height()),
                        I.removeClass("fancybox-tmp"));
                }
                if (
                    ((M = r(X)),
                    (p = r(W)),
                    (T = X / W),
                    (o = r(s(o) ? r(o, "w") - Z : o)),
                    (h = r(s(h) ? r(h, "w") - Z : h)),
                    (n = r(s(n) ? r(n, "h") - Y : n)),
                    (c = r(s(c) ? r(c, "h") - Y : c)),
                    (V = h),
                    (U = c),
                    G.fitToView &&
                        ((h = Math.min(R.w - Z, h)),
                        (c = Math.min(R.h - Y, c))),
                    (Z = R.w - J),
                    (H = R.h - H),
                    G.aspectRatio
                        ? (M > h && ((M = h), (p = r(M / T))),
                          p > c && ((p = c), (M = r(p * T))),
                          M < o && ((M = o), (p = r(M / T))),
                          p < n && ((p = n), (M = r(p * T))))
                        : ((M = Math.max(o, Math.min(M, h))),
                          G.autoHeight &&
                              "iframe" !== G.type &&
                              (I.width(M), (p = I.height())),
                          (p = Math.max(n, Math.min(p, c)))),
                    G.fitToView)
                ) {
                    if (
                        (I.width(M).height(p),
                        O.width(M + L),
                        (R = O.width()),
                        (J = O.height()),
                        G.aspectRatio)
                    ) {
                        for (
                            ;
                            (R > Z || J > H) && M > o && p > n && !(19 < Q++);

                        ) {
                            (p = Math.max(n, Math.min(c, p - 10))),
                                (M = r(p * T)),
                                M < o && ((M = o), (p = r(M / T))),
                                M > h && ((M = h), (p = r(M / T))),
                                I.width(M).height(p),
                                O.width(M + L),
                                (R = O.width()),
                                (J = O.height());
                        }
                    } else {
                        (M = Math.max(o, Math.min(M, M - (R - Z)))),
                            (p = Math.max(n, Math.min(p, p - (J - H))));
                    }
                }
                N && "auto" === P && p < W && M + L + N < Z && (M += N),
                    I.width(M).height(p),
                    O.width(M + L),
                    (R = O.width()),
                    (J = O.height()),
                    (O = (R > Z || J > H) && M > o && p > n),
                    (M = G.aspectRatio
                        ? M < V && p < U && M < X && p < W
                        : (M < V || p < U) && (M < X || p < W)),
                    D.extend(G, {
                        dim: { width: q(R), height: q(J) },
                        origWidth: X,
                        origHeight: W,
                        canShrink: O,
                        canExpand: M,
                        wPadding: L,
                        hPadding: aa,
                        wrapSpace: J - K.outerHeight(!0),
                        skinSpace: K.height() - p,
                    }),
                    !S &&
                        G.autoHeight &&
                        p > n &&
                        p < c &&
                        !M &&
                        I.height("auto");
            },
            _getPosition: function (h) {
                var g = y.current,
                    l = y.getViewport(),
                    k = g.margin,
                    j = y.wrap.width() + k[1] + k[3],
                    i = y.wrap.height() + k[0] + k[2] - 40,
                    k = { position: "absolute", top: k[0], left: k[3] };
                return (
                    g.autoCenter && g.fixed && !h && i <= l.h && j <= l.w
                        ? (k.position = "fixed")
                        : g.locked || ((k.top += l.y), (k.left += l.x)),
                    (k.top = q(
                        Math.max(k.top, k.top + (l.h - i) * g.topRatio)
                    )),
                    (k.left = q(
                        Math.max(k.left, k.left + (l.w - j) * g.leftRatio)
                    )),
                    k
                );
            },
            _afterZoomIn: function () {
                var b = y.current;
                b &&
                    ((y.isOpen = y.isOpened = !0),
                    y.wrap
                        .css("overflow", "visible")
                        .addClass("fancybox-opened"),
                    y.update(),
                    (b.closeClick || (b.nextClick && 1 < y.group.length)) &&
                        y.inner
                            .css("cursor", "pointer")
                            .bind("click.fb", function (a) {
                                !D(a.target).is("a") &&
                                    !D(a.target).parent().is("a") &&
                                    (a.preventDefault(),
                                    y[b.closeClick ? "close" : "next"]());
                            }),
                    b.closeBtn &&
                        D(b.tpl.closeBtn)
                            .appendTo(y.skin)
                            .bind("click.fb", function (c) {
                                c.preventDefault(), y.close();
                            }),
                    b.arrows &&
                        1 < y.group.length &&
                        ((b.loop || 0 < b.index) &&
                            D(b.tpl.prev)
                                .appendTo(y.outer)
                                .bind("click.fb", y.prev),
                        (b.loop || b.index < y.group.length - 1) &&
                            D(b.tpl.next)
                                .appendTo(y.outer)
                                .bind("click.fb", y.next)),
                    y.trigger("afterShow"),
                    b.loop || b.index !== b.group.length - 1
                        ? y.opts.autoPlay &&
                          !y.player.isActive &&
                          ((y.opts.autoPlay = !1), y.play())
                        : y.play(!1));
            },
            _afterZoomOut: function (b) {
                (b = b || y.current),
                    D(".fancybox-wrap").trigger("onReset").remove(),
                    D.extend(y, {
                        group: {},
                        opts: {},
                        router: !1,
                        current: null,
                        isActive: !1,
                        isOpened: !1,
                        isOpen: !1,
                        isClosing: !1,
                        wrap: null,
                        skin: null,
                        outer: null,
                        inner: null,
                    }),
                    y.trigger("afterClose", b);
            },
        }),
            (y.transitions = {
                getOrigPosition: function () {
                    var H = y.current,
                        G = H.element,
                        p = H.orig,
                        o = {},
                        n = 50,
                        m = 50,
                        l = H.hPadding,
                        k = H.wPadding,
                        h = y.getViewport();
                    return (
                        !p &&
                            H.isDom &&
                            G.is(":visible") &&
                            ((p = G.find("img:first")), p.length || (p = G)),
                        u(p)
                            ? ((o = p.offset()),
                              p.is("img") &&
                                  ((n = p.outerWidth()), (m = p.outerHeight())))
                            : ((o.top = h.y + (h.h - m) * H.topRatio),
                              (o.left = h.x + (h.w - n) * H.leftRatio)),
                        ("fixed" === y.wrap.css("position") || H.locked) &&
                            ((o.top -= h.y), (o.left -= h.x)),
                        (o = {
                            top: q(o.top - l * H.topRatio),
                            left: q(o.left - k * H.leftRatio),
                            width: q(n + k),
                            height: q(m + l),
                        })
                    );
                },
                step: function (i, h) {
                    var n,
                        m,
                        l = h.prop;
                    m = y.current;
                    var k = m.wrapSpace,
                        j = m.skinSpace;
                    ("width" !== l && "height" !== l) ||
                        ((n =
                            h.end === h.start
                                ? 1
                                : (i - h.start) / (h.end - h.start)),
                        y.isClosing && (n = 1 - n),
                        (m = "width" === l ? m.wPadding : m.hPadding),
                        (m = i - m),
                        y.skin[l](r("width" === l ? m : m - k * n)),
                        y.inner[l](r("width" === l ? m : m - k * n - j * n)));
                },
                zoomIn: function () {
                    var g = y.current,
                        c = g.pos,
                        j = g.openEffect,
                        i = "elastic" === j,
                        h = D.extend({ opacity: 1 }, c);
                    delete h.position,
                        i
                            ? ((c = this.getOrigPosition()),
                              g.openOpacity && (c.opacity = 0.1))
                            : "fade" === j && (c.opacity = 0.1),
                        y.wrap
                            .css(c)
                            .animate(h, {
                                duration: "none" === j ? 0 : g.openSpeed,
                                easing: g.openEasing,
                                step: i ? this.step : null,
                                complete: y._afterZoomIn,
                            });
                },
                zoomOut: function () {
                    var f = y.current,
                        e = f.closeEffect,
                        h = "elastic" === e,
                        g = { opacity: 0.1 };
                    h &&
                        ((g = this.getOrigPosition()),
                        f.closeOpacity && (g.opacity = 0.1)),
                        y.wrap.animate(g, {
                            duration: "none" === e ? 0 : f.closeSpeed,
                            easing: f.closeEasing,
                            step: h ? this.step : null,
                            complete: y._afterZoomOut,
                        });
                },
                changeIn: function () {
                    var h,
                        g = y.current,
                        l = g.nextEffect,
                        k = g.pos,
                        j = { opacity: 1 },
                        i = y.direction;
                    (k.opacity = 0.1),
                        "elastic" === l &&
                            ((h = "down" === i || "up" === i ? "top" : "left"),
                            "down" === i || "right" === i
                                ? ((k[h] = q(r(k[h]) - 200)),
                                  (j[h] = "+=200px"))
                                : ((k[h] = q(r(k[h]) + 200)),
                                  (j[h] = "-=200px"))),
                        "none" === l
                            ? y._afterZoomIn()
                            : y.wrap
                                  .css(k)
                                  .animate(j, {
                                      duration: g.nextSpeed,
                                      easing: g.nextEasing,
                                      complete: y._afterZoomIn,
                                  });
                },
                changeOut: function () {
                    var f = y.previous,
                        c = f.prevEffect,
                        h = { opacity: 0.1 },
                        g = y.direction;
                    "elastic" === c &&
                        (h["down" === g || "up" === g ? "top" : "left"] =
                            ("up" === g || "left" === g ? "-" : "+") +
                            "=200px"),
                        f.wrap.animate(h, {
                            duration: "none" === c ? 0 : f.prevSpeed,
                            easing: f.prevEasing,
                            complete: function () {
                                D(this).trigger("onReset").remove();
                            },
                        });
                },
            }),
            (y.helpers.overlay = {
                defaults: {
                    closeClick: !0,
                    speedOut: 200,
                    showEarly: !0,
                    css: {},
                    locked: !v,
                    fixed: !0,
                },
                overlay: null,
                fixed: !1,
                el: D("html"),
                create: function (b) {
                    (b = D.extend({}, this.defaults, b)),
                        this.overlay && this.close(),
                        (this.overlay = D(
                            '<div class="fancybox-overlay"></div>'
                        ).appendTo(y.coming ? y.coming.parent : b.parent)),
                        (this.fixed = !1),
                        b.fixed &&
                            y.defaults.fixed &&
                            (this.overlay.addClass("fancybox-overlay-fixed"),
                            (this.fixed = !0));
                },
                open: function (d) {
                    var c = this;
                    (d = D.extend({}, this.defaults, d)),
                        this.overlay
                            ? this.overlay
                                  .unbind(".overlay")
                                  .width("auto")
                                  .height("auto")
                            : this.create(d),
                        this.fixed ||
                            (A.bind(
                                "resize.overlay",
                                D.proxy(this.update, this)
                            ),
                            this.update()),
                        d.closeClick &&
                            this.overlay.bind("click.overlay", function (b) {
                                if (D(b.target).hasClass("fancybox-overlay")) {
                                    return (
                                        y.isActive ? y.close() : c.close(), !1
                                    );
                                }
                            }),
                        this.overlay.css(d.css).show();
                },
                close: function () {
                    var d, c;
                    A.unbind("resize.overlay"),
                        this.el.hasClass("fancybox-lock") &&
                            (D(".fancybox-margin").removeClass(
                                "fancybox-margin"
                            ),
                            (d = A.scrollTop()),
                            (c = A.scrollLeft()),
                            this.el.removeClass("fancybox-lock"),
                            A.scrollTop(d).scrollLeft(c)),
                        D(".fancybox-overlay").remove().hide(),
                        D.extend(this, { overlay: null, fixed: !1 });
                },
                update: function () {
                    var b,
                        d = "100%";
                    this.overlay.width(d).height("100%"),
                        x
                            ? ((b = Math.max(
                                  E.documentElement.offsetWidth,
                                  E.body.offsetWidth
                              )),
                              z.width() > b && (d = z.width()))
                            : z.width() > A.width() && (d = z.width()),
                        this.overlay.width(d).height(z.height());
                },
                onReady: function (e, c) {
                    var f = this.overlay;
                    D(".fancybox-overlay").stop(!0, !0),
                        f || this.create(e),
                        e.locked &&
                            this.fixed &&
                            c.fixed &&
                            (f ||
                                (this.margin =
                                    z.height() > A.height() &&
                                    D("html")
                                        .css("margin-right")
                                        .replace("px", "")),
                            (c.locked = this.overlay.append(c.wrap)),
                            (c.fixed = !1)),
                        !0 === e.showEarly &&
                            this.beforeShow.apply(this, arguments);
                },
                beforeShow: function (f, c) {
                    var h, g;
                    c.locked &&
                        (!1 !== this.margin &&
                            (D("*")
                                .filter(function () {
                                    return (
                                        "fixed" === D(this).css("position") &&
                                        !D(this).hasClass("fancybox-overlay") &&
                                        !D(this).hasClass("fancybox-wrap")
                                    );
                                })
                                .addClass("fancybox-margin"),
                            this.el.addClass("fancybox-margin")),
                        (h = A.scrollTop()),
                        (g = A.scrollLeft()),
                        this.el.addClass("fancybox-lock"),
                        A.scrollTop(h).scrollLeft(g)),
                        this.open(f);
                },
                onUpdate: function () {
                    this.fixed || this.update();
                },
                afterClose: function (b) {
                    this.overlay &&
                        !y.coming &&
                        this.overlay.fadeOut(
                            b.speedOut,
                            D.proxy(this.close, this)
                        );
                },
            }),
            (y.helpers.title = {
                defaults: { type: "float", position: "bottom" },
                beforeShow: function (f) {
                    var c = y.current,
                        h = c.title,
                        g = f.type;
                    if (
                        (D.isFunction(h) && (h = h.call(c.element, c)),
                        t(h) && "" !== D.trim(h))
                    ) {
                        switch (
                            ((c = D(
                                '<div class="fancybox-title fancybox-title-' +
                                    g +
                                    '-wrap">' +
                                    h +
                                    "</div>"
                            )),
                            g)
                        ) {
                            case "inside":
                                g = y.skin;
                                break;
                            case "outside":
                                g = y.wrap;
                                break;
                            case "over":
                                g = y.inner;
                                break;
                            default:
                                (g = y.skin),
                                    c.appendTo("body"),
                                    x && c.width(c.width()),
                                    c.wrapInner('<span class="child"></span>'),
                                    (y.current.margin[2] += Math.abs(
                                        r(c.css("margin-bottom"))
                                    ));
                        }
                        c["top" === f.position ? "prependTo" : "appendTo"](g);
                    }
                },
            }),
            (D.fn.fancyboxY = function (g) {
                var c,
                    j = D(this),
                    i = this.selector || "",
                    h = function (l) {
                        var e,
                            d,
                            b = D(this).blur(),
                            a = c;
                        !l.ctrlKey &&
                            !l.altKey &&
                            !l.shiftKey &&
                            !l.metaKey &&
                            !b.is(".fancybox-wrap") &&
                            ((e = g.groupAttr || "data-fancybox-group"),
                            (d = b.attr(e)),
                            d || ((e = "rel"), (d = b.get(0)[e])),
                            d &&
                                "" !== d &&
                                "nofollow" !== d &&
                                ((b = i.length ? D(i) : j),
                                (b = b.filter("[" + e + '="' + d + '"]')),
                                (a = b.index(this))),
                            (g.index = a),
                            !1 !== y.open(b, g) && l.preventDefault());
                    };
                return (
                    (g = g || {}),
                    (c = g.index || 0),
                    i && !1 !== g.live
                        ? z
                              .undelegate(i, "click.fb-start")
                              .delegate(
                                  i + ":not('.fancybox-item, .fancybox-nav')",
                                  "click.fb-start",
                                  h
                              )
                        : j.unbind("click.fb-start").bind("click.fb-start", h),
                    this.filter("[data-fancybox-start=1]").trigger("click"),
                    this
                );
            }),
            z.ready(function () {
                var a, d;
                if (
                    (D.scrollbarWidth === C &&
                        (D.scrollbarWidth = function () {
                            var f = D(
                                    '<div style="width:50px;height:50px;overflow:auto"><div/></div>'
                                ).appendTo("body"),
                                e = f.children(),
                                e = e.innerWidth() - e.height(99).innerWidth();
                            return f.remove(), e;
                        }),
                    D.support.fixedPosition === C)
                ) {
                    (a = D.support),
                        (d = D(
                            '<div style="position:fixed;top:20px;"></div>'
                        ).appendTo("body"));
                    var c = 20 === d[0].offsetTop || 15 === d[0].offsetTop;
                    d.remove(), (a.fixedPosition = c);
                }
                D.extend(y.defaults, {
                    scrollbarWidth: D.scrollbarWidth(),
                    fixed: D.support.fixedPosition,
                    parent: D("body"),
                }),
                    (a = D(F).width()),
                    B.addClass("fancybox-lock-test"),
                    (d = D(F).width()),
                    B.removeClass("fancybox-lock-test"),
                    D(
                        "<style type='text/css'>.fancybox-margin{margin-right:" +
                            (d - a) +
                            "px;}</style>"
                    ).appendTo("head");
            });
    })(window, document, jQuery),
    function () {
        var d, c;
        (d = (function () {
            function b(f, e) {
                var h, g;
                if (
                    ((this.options = {
                        target: "instafeed",
                        get: "popular",
                        resolution: "thumbnail",
                        sortBy: "none",
                        links: !0,
                        mock: !1,
                        useHttp: !1,
                    }),
                    "object" == typeof f)
                ) {
                    for (h in f) {
                        (g = f[h]), (this.options[h] = g);
                    }
                }
                (this.context = null != e ? e : this),
                    (this.unique = this._genKey());
            }
            return (
                (b.prototype.hasNext = function () {
                    return (
                        "string" == typeof this.context.nextUrl &&
                        this.context.nextUrl.length > 0
                    );
                }),
                (b.prototype.next = function () {
                    return !!this.hasNext() && this.run(this.context.nextUrl);
                }),
                (b.prototype.run = function (a) {
                    var h, g, f;
                    if (
                        "string" != typeof this.options.clientId &&
                        "string" != typeof this.options.accessToken
                    ) {
                        throw new Error("Missing clientId or accessToken.");
                    }
                    if (
                        "string" != typeof this.options.accessToken &&
                        "string" != typeof this.options.clientId
                    ) {
                        throw new Error("Missing clientId or accessToken.");
                    }
                    return (
                        null != this.options.before &&
                            "function" == typeof this.options.before &&
                            this.options.before.call(this),
                        "undefined" != typeof document &&
                            null !== document &&
                            ((f = document.createElement("script")),
                            (f.id = "instafeed-fetcher"),
                            (f.src = a || this._buildUrl()),
                            (h = document.getElementsByTagName("head")),
                            h[0].appendChild(f),
                            (g = "instafeedCache" + this.unique),
                            (window[g] = new b(this.options, this)),
                            (window[g].unique = this.unique)),
                        !0
                    );
                }),
                (b.prototype.parse = function (T) {
                    var S,
                        R,
                        Q,
                        P,
                        O,
                        N,
                        M,
                        L,
                        K,
                        J,
                        I,
                        H,
                        G,
                        F,
                        E,
                        D,
                        C,
                        B,
                        A,
                        z,
                        y,
                        x;
                    if ("object" != typeof T) {
                        if (
                            null != this.options.error &&
                            "function" == typeof this.options.error
                        ) {
                            return (
                                this.options.error.call(
                                    this,
                                    "Invalid JSON data"
                                ),
                                !1
                            );
                        }
                        throw new Error("Invalid JSON response");
                    }
                    if (200 !== T.meta.code) {
                        if (
                            null != this.options.error &&
                            "function" == typeof this.options.error
                        ) {
                            return (
                                this.options.error.call(
                                    this,
                                    T.meta.error_message
                                ),
                                !1
                            );
                        }
                        throw new Error(
                            "Error from Instagram: " + T.meta.error_message
                        );
                    }
                    if (0 === T.data.length) {
                        if (
                            null != this.options.error &&
                            "function" == typeof this.options.error
                        ) {
                            return (
                                this.options.error.call(
                                    this,
                                    "No images were returned from Instagram"
                                ),
                                !1
                            );
                        }
                        throw new Error(
                            "No images were returned from Instagram"
                        );
                    }
                    if (
                        (null != this.options.success &&
                            "function" == typeof this.options.success &&
                            this.options.success.call(this, T),
                        (this.context.nextUrl = ""),
                        null != T.pagination &&
                            (this.context.nextUrl = T.pagination.next_url),
                        "none" !== this.options.sortBy)
                    ) {
                        switch (
                            ((F =
                                "random" === this.options.sortBy
                                    ? ["", "random"]
                                    : this.options.sortBy.split("-")),
                            (G = "least" === F[0]),
                            F[1])
                        ) {
                            case "random":
                                T.data.sort(function () {
                                    return 0.5 - Math.random();
                                });
                                break;
                            case "recent":
                                T.data = this._sortBy(
                                    T.data,
                                    "created_time",
                                    G
                                );
                                break;
                            case "liked":
                                T.data = this._sortBy(T.data, "likes.count", G);
                                break;
                            case "commented":
                                T.data = this._sortBy(
                                    T.data,
                                    "comments.count",
                                    G
                                );
                                break;
                            default:
                                throw new Error(
                                    "Invalid option for sortBy: '" +
                                        this.options.sortBy +
                                        "'."
                                );
                        }
                    }
                    if (
                        "undefined" != typeof document &&
                        null !== document &&
                        this.options.mock === !1
                    ) {
                        if (
                            ((L = T.data),
                            null != this.options.limit &&
                                L.length > this.options.limit &&
                                (L = L.slice(
                                    0,
                                    this.options.limit + 1 || 9000000000
                                )),
                            (R = document.createDocumentFragment()),
                            null != this.options.filter &&
                                "function" == typeof this.options.filter &&
                                (L = this._filter(L, this.options.filter)),
                            null != this.options.template &&
                                "string" == typeof this.options.template)
                        ) {
                            for (
                                P = "",
                                    N = "",
                                    J = "",
                                    E = document.createElement("div"),
                                    D = 0,
                                    A = L.length;
                                D < A;
                                D++
                            ) {
                                (O = L[D]),
                                    (M = O.images[this.options.resolution].url),
                                    this.options.useHttp ||
                                        (M = M.replace("http://", "//")),
                                    (N = this._makeTemplate(
                                        this.options.template,
                                        {
                                            model: O,
                                            id: O.id,
                                            link: O.link,
                                            image: M,
                                            caption: this._getObjectProperty(
                                                O,
                                                "caption.text"
                                            ),
                                            likes: O.likes.count,
                                            comments: O.comments.count,
                                            location: this._getObjectProperty(
                                                O,
                                                "location.name"
                                            ),
                                        }
                                    )),
                                    (P += N);
                            }
                            for (
                                E.innerHTML = P,
                                    x = [].slice.call(E.childNodes),
                                    C = 0,
                                    z = x.length;
                                C < z;
                                C++
                            ) {
                                (H = x[C]), R.appendChild(H);
                            }
                        } else {
                            for (B = 0, y = L.length; B < y; B++) {
                                (O = L[B]),
                                    (K = document.createElement("img")),
                                    (M = O.images[this.options.resolution].url),
                                    this.options.useHttp ||
                                        (M = M.replace("http://", "//")),
                                    (K.src = M),
                                    this.options.links === !0
                                        ? ((S = document.createElement("a")),
                                          (S.href = O.link),
                                          S.appendChild(K),
                                          R.appendChild(S))
                                        : R.appendChild(K);
                            }
                        }
                        document
                            .getElementById(this.options.target)
                            .appendChild(R),
                            (Q = document.getElementsByTagName("head")[0]),
                            Q.removeChild(
                                document.getElementById("instafeed-fetcher")
                            ),
                            (I = "instafeedCache" + this.unique),
                            (window[I] = void 0);
                        try {
                            delete window[I];
                        } catch (T) {}
                    }
                    return (
                        null != this.options.after &&
                            "function" == typeof this.options.after &&
                            this.options.after.call(this),
                        !0
                    );
                }),
                (b.prototype._buildUrl = function () {
                    var f, e, g;
                    switch (
                        ((f = "https://api.instagram.com/v1"), this.options.get)
                    ) {
                        case "popular":
                            e = "media/popular";
                            break;
                        case "tagged":
                            if ("string" != typeof this.options.tagName) {
                                throw new Error(
                                    "No tag name specified. Use the 'tagName' option."
                                );
                            }
                            e =
                                "tags/" +
                                this.options.tagName +
                                "/media/recent";
                            break;
                        case "location":
                            if ("number" != typeof this.options.locationId) {
                                throw new Error(
                                    "No location specified. Use the 'locationId' option."
                                );
                            }
                            e =
                                "locations/" +
                                this.options.locationId +
                                "/media/recent";
                            break;
                        case "user":
                            if ("number" != typeof this.options.userId) {
                                throw new Error(
                                    "No user specified. Use the 'userId' option."
                                );
                            }
                            if ("string" != typeof this.options.accessToken) {
                                throw new Error(
                                    "No access token. Use the 'accessToken' option."
                                );
                            }
                            e =
                                "users/" +
                                this.options.userId +
                                "/media/recent";
                            break;
                        default:
                            throw new Error(
                                "Invalid option for get: '" +
                                    this.options.get +
                                    "'."
                            );
                    }
                    return (
                        (g = "" + f + "/" + e),
                        (g +=
                            null != this.options.accessToken
                                ? "?access_token=" + this.options.accessToken
                                : "?client_id=" + this.options.clientId),
                        null != this.options.limit &&
                            (g += "&count=" + this.options.limit),
                        (g +=
                            "&callback=instafeedCache" + this.unique + ".parse")
                    );
                }),
                (b.prototype._genKey = function () {
                    var e;
                    return (
                        (e = function () {
                            return ((65536 * (1 + Math.random())) | 0)
                                .toString(16)
                                .substring(1);
                        }),
                        "" + e() + e() + e() + e()
                    );
                }),
                (b.prototype._makeTemplate = function (i, h) {
                    var n, m, l, k, j;
                    for (
                        m = /(?:\2)([\w\[\]\.]+)(?:\}{2})/, n = i;
                        m.test(n);

                    ) {
                        (l = n.match(m)[1]),
                            (k =
                                null != (j = this._getObjectProperty(h, l))
                                    ? j
                                    : ""),
                            (n = n.replace(m, "" + k));
                    }
                    return n;
                }),
                (b.prototype._getObjectProperty = function (f, e) {
                    var h, g;
                    for (
                        e = e.replace(/\[(\w+)\]/g, ".$1"), g = e.split(".");
                        g.length;

                    ) {
                        if (((h = g.shift()), !(null != f && h in f))) {
                            return null;
                        }
                        f = f[h];
                    }
                    return f;
                }),
                (b.prototype._sortBy = function (f, e, h) {
                    var g;
                    return (
                        (g = function (i, l) {
                            var k, j;
                            return (
                                (k = this._getObjectProperty(i, e)),
                                (j = this._getObjectProperty(l, e)),
                                h ? (k > j ? 1 : -1) : k < j ? 1 : -1
                            );
                        }),
                        f.sort(g.bind(this)),
                        f
                    );
                }),
                (b.prototype._filter = function (i, h) {
                    var n, m, l, k, j;
                    for (
                        n = [],
                            l = function (e) {
                                if (h(e)) {
                                    return n.push(e);
                                }
                            },
                            k = 0,
                            j = i.length;
                        k < j;
                        k++
                    ) {
                        (m = i[k]), l(m);
                    }
                    return n;
                }),
                b
            );
        })()),
            (c =
                "undefined" != typeof exports && null !== exports
                    ? exports
                    : window),
            (c.Instafeed = d);
    }.call(this);